"use strict";
/* File automatically generated! Do not add or modify anything as it will be overridden! */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnergyAcquisitionDataPreference_V0Migration = exports.EnergyAcquisitionCustomerAccountRole_V0Migration = exports.EnergyAcquisitionCustomerAccountRoleInput = exports.EnergyAcquisitionCustomerAccountRole = exports.EnergyAcquisitionCurrencyCode_V0Migration = exports.EnergyAcquisitionCriticalCode_V0Migration = exports.EnergyAcquisitionConsentType_V0Migration = exports.EnergisationStatus = exports.ElectricVehicleType = exports.ElectricVehiclePowerTransferType = exports.ElectricVehicleOptimisationMode = exports.ElectricVehicleNotUnderControlReason = exports.ElectricVehicleNoPowerTransferReason = exports.DeviceType = exports.DemandRateAccountingWindow = exports.CustomerType = exports.CustomerTitle = exports.CustomerStatus = exports.CustomerAccountRole_NextV1 = exports.CustomerAccountRole = exports.CurrencyInput = exports.CurrencyCode = exports.CreditDebitType = exports.ControllableThrough = exports.ContractTariffEntryStartReason = exports.ContractStartEventReason = exports.ContractEndEventReason = exports.ConsumptionChargeGasUnitOfMeasurement = exports.ConsentType = exports.ConsentLevel = exports.ConcessionRegion = exports.ConcessionCardType = exports.ConcessionCard = exports.ComparisonValue = exports.ComparisonType = exports.CommunicationChannel = exports.CommsPreference = exports.ChargingPipeline = exports.CardScheme = exports.BlockRateAccountingWindow = exports.BillType = exports.BillFrequencyType = exports.BalanceCategory = exports.AppointmentTimeWindow = exports.ApplicableDay = exports.ApplicabilityCalculatedOn = exports.ActionType = exports.AccountReferenceType = exports.AccountEventType = exports.AccountEventSentStatus = void 0;
exports.PaymentScheduleStatus = exports.PaymentMethodV3 = exports.PaymentMethod = exports.PaymentMandateType = exports.PaymentMandateStatus_NextV1 = exports.PaymentMandateStatus = exports.PaymentChannel = exports.MigrationUnbilledTransactionTypeEtl = exports.MigrationTaskStatus = exports.MigrationStatus = exports.MigrationRecurringPaymentStatus = exports.MigrationRecurringPaymentFrequencySchedule = exports.MigrationMeterTypeEtl = exports.MigrationMeterType = exports.MigrationMeterReadSource = exports.MigrationMeterPaymentMode = exports.MigrationEmailAddressType = exports.MigrationCustomerStatus = exports.MigrationCreditDebitType = exports.MigrationBillingFrequency = exports.MigrationBalanceDebtItemType = exports.MigrationBackfillStatus = exports.MigrationBackfillRequestStatus = exports.MeterStatus = exports.MeterReadSource = exports.MeterReadForceType = exports.MarketSector = exports.ManagedExceptionStatus = exports.ManagedExceptionAssignmentAction = exports.LifeSupportProtectionStatus = exports.LifeSupportEquipmentType = exports.LedgerCreditDebitType = exports.KaluzaPlatformRegion = exports.IntervalPowerFlow = exports.IntervalFlag = exports.FullMeterReadSource = exports.Fuel = exports.EventType = exports.EnergyUnitOfMeasurement = exports.EnergyAcquisitionTitle_V0Migration = exports.EnergyAcquisitionTitle = exports.EnergyAcquisitionTariffCategory_V0Migration = exports.EnergyAcquisitionState_V0Migration = exports.EnergyAcquisitionState = exports.EnergyAcquisitionServiceCommunicationPreference_V0Migration = exports.EnergyAcquisitionPaymentMethod_V0Migration = exports.EnergyAcquisitionPaymentInstruction_V0Migration = exports.EnergyAcquisitionMeterMode_V0Migration = exports.EnergyAcquisitionMedicareCardColour = exports.EnergyAcquisitionIdentificationType = void 0;
exports.UrgentChargeMode = exports.UpdateCustomerAccountRole_NextV1 = exports.TransactionBalanceCategory = exports.TokenisedPaymentOrigin = exports.TimingConfigurationSeasonality = exports.TimingCategory = exports.TimeOfUseSearchType = exports.TaxCategory = exports.TariffType = exports.TariffPaymentMethod = exports.TariffPaymentMechanism = exports.SupplyPointTimingCategory = exports.SupplyFuel = exports.SubjectType = exports.StringSearchMatcher = exports.StringSearchCaseSensitivity = exports.StatementType = exports.StatementReadType = exports.SpecialCommunicationsPreference = exports.SiteHazardType = exports.ScheduleFrequency = exports.SaleValidationStatus_V0Migration = exports.SaleType_V0Migration = exports.SaleType = exports.RegionValue = exports.RegionCode = exports.RecurringPaymentType = exports.RecurringPaymentStatus = exports.RecurringPaymentFrequencySchedule = exports.ReadingType_NextV1 = exports.ReadingType = exports.ReadingLifecycle = exports.ReadType = exports.ReadSource = exports.ReadLifecycle = exports.ReadGasUnitOfMeasure = exports.ReadElectricityUnitOfMeasure = exports.QueryType = exports.ProvenanceType = exports.ProductVersionPriceUnit = exports.ProductVersionDurationTimeUnit = exports.ProductChargeType = exports.PowerFlow = exports.PolicyName = exports.PayoutEligibilityReasonCode = exports.PaymentType = exports.PaymentStatusV3 = exports.PaymentStatus = exports.PaymentSourceType = exports.PaymentServiceProvider = void 0;
exports.ValidationType = exports.UsageType = void 0;
var result = {
    possibleTypes: {
        AccountEvent: ['CommEvent', 'GenericEvent', 'MemoEvent', 'StatementEvent'],
        AccountEventDeliveredTo: [
            'AccountEventDeliveredToEmail',
            'AccountEventDeliveredToPhone',
            'PostalAddress',
        ],
        AgentSearchQueryResult: [
            'AccountAgentSearchQueryResult',
            'CustomerAgentSearchQueryResult',
            'SupplyAgentSearchQueryResult',
        ],
        ApplicableOn: ['ApplicableAllYear', 'ApplicableDateRange'],
        BaseSubmissionMeterRead: [
            'ElectricityMeterRead_nextV1',
            'GasMeterRead_nextV1',
        ],
        BillCustomer: ['BilledCustomer', 'NamedCustomer'],
        Comparator: ['Comparison', 'Criteria'],
        CompleteMigrationError: [
            'InvalidInputError',
            'MigrationStateError',
            'SystemError',
            'UnauthorizedError',
        ],
        ConcessionDiscount: [
            'DiscountFixedConsumption',
            'DiscountFixedPrice',
            'DiscountPercentageBased',
            'DiscountServiceChargeToUsage',
        ],
        Connection: [
            'AccountHistoryConnection',
            'AccountHistoryConnection_nextV1',
            'ActiveBillingHoldConnection',
            'AppliedConcessionConnection',
            'ConsumptionChargeConnection',
            'ContractConnection',
            'ContractConnection_nextV1',
            'CustomerAccountRelationshipConnection_nextV1',
            'CustomerConcessionCardConnection',
            'CustomerConnection_nextV1',
            'EligibleFlexibleEnergyDeviceConnection',
            'EnergyAcquisitionConnection',
            'EnergyAcquisition_V0MigrationConnection',
            'EventsGatewaySubscriptionConnection',
            'LedgerTransactionConnection',
            'LifeSupportProtectionConnection',
            'ManagedExceptionConnection',
            'ManagedExceptionFilterConnection',
            'MeterIntervalDataConnection',
            'MeterReadConnection',
            'MigrationBackfillConnection',
            'PaymentConnection',
            'PaymentEventConnection',
            'PaymentMandateConnection',
            'PaymentMandateConnection_nextV1',
            'PaymentScheduleConnection',
            'PaymentScheduleConnection_nextV1',
            'PaymentTransactionConnection',
            'ProductVersionConnection',
            'ProjectedConsumptionConnection',
            'PropertySupplyPointConnection',
            'SupplyPointConnection',
            'TariffConnection_nextV1',
            'TransactionTypeConnection_nextV1',
        ],
        DiscountConsumptionLimit: [
            'MaximumConsumptionLimit',
            'MinimumConsumptionLimit',
        ],
        Edge: [
            'AccountHistoryEdge',
            'AccountHistoryEdge_nextV1',
            'ActiveBillingHoldEdge',
            'AgentSearchQueryResultEdge',
            'AppliedConcessionEdge',
            'BillingDataPacketEdge',
            'ConsumptionChargeEdge',
            'ContractEdge',
            'ContractEdge_nextV1',
            'CustomerAccountRelationshipEdge_nextV1',
            'CustomerConcessionCardEdge',
            'CustomerEdge_nextV1',
            'EligibleFlexibleEnergyDeviceEdge',
            'EnergyAcquisitionEdge',
            'EnergyAcquisition_V0MigrationEdge',
            'EventsGatewaySubscriptionEdge',
            'LedgerTransactionEdge',
            'LifeSupportProtectionEdge',
            'ManagedExceptionEdge',
            'ManagedExceptionFilterEdge',
            'MeterIntervalDataEdge',
            'MeterReadEdge',
            'MigrationBackfillEdge',
            'PaymentEdge',
            'PaymentEventEdge',
            'PaymentMandateEdge',
            'PaymentMandateEdge_nextV1',
            'PaymentScheduleEdge',
            'PaymentScheduleEdge_nextV1',
            'PaymentSearchQueryResultEdge',
            'PaymentTransactionEdge',
            'ProductVersionEdge',
            'ProjectedConsumptionEdge',
            'PropertySupplyPointEdge',
            'SupplyPointEdge',
            'TariffEdge_nextV1',
            'TransactionTypeEdge_nextV1',
        ],
        ElectricVehicleChargeState: [
            'ElectricVehicleControlledNoPowerTransfer',
            'ElectricVehicleControlledPowerTransfer',
            'ElectricVehicleNotUnderControl',
        ],
        EligibleDeviceYears: ['AllYearsOfCompatibility', 'FromYearOfCompatibility'],
        EligibleFlexibleEnergyDevice: [
            'EligibleFlexibleEnergyElectricVehicle',
            'EligibleFlexibleEnergyElectricVehicleCharger',
            'EligibleFlexibleEnergySolarInverter',
        ],
        EnergyProjection: ['ElectricityAnnualProjection', 'GasAnnualProjection'],
        Error: [
            'InvalidInputError',
            'MigrationStateError',
            'MigrationTaskError',
            'MigrationValidationFailure',
            'SystemError',
            'UnauthorizedError',
            'ValidationError',
        ],
        FlexibleEnergyDevice: [
            'ElectricVehicle',
            'ElectricVehicleCharger',
            'SolarInverter',
        ],
        LifeSupportUpdateTrigger: [
            'LifeSupportApiCaller',
            'LifeSupportAutomaticDeRegistration',
            'LifeSupportDistributorNotification',
        ],
        MeterRead: ['ElectricityMeterRead', 'GasMeterRead'],
        MeterRegister: ['BasicMeterRegister', 'IntervalMeterRegister'],
        Node: [
            'AccountAgentSearchQueryResult',
            'AccountHistoryEvent',
            'AccountHistoryEvent_nextV1',
            'Account_nextV1',
            'ActiveBillingHold',
            'AppliedConcession',
            'BillingDataPacket',
            'ConsumptionCharge',
            'Contract',
            'Contract_nextV1',
            'CustomerAccountRelationship_nextV1',
            'CustomerAgentSearchQueryResult',
            'CustomerConcessionCard',
            'Customer_nextV1',
            'ElectricityAnnualProjection',
            'EligibleFlexibleEnergyElectricVehicle',
            'EligibleFlexibleEnergyElectricVehicleCharger',
            'EligibleFlexibleEnergySolarInverter',
            'EnergyAcquisition',
            'EnergyAcquisition_V0Migration',
            'EventsGatewaySubscription',
            'GasAnnualProjection',
            'InValidReading',
            'IntervalBlock',
            'LedgerTransactionNode',
            'LifeSupportProtection',
            'ManagedException',
            'ManagedExceptionFilter',
            'MigrationBackfillRequest',
            'Payment',
            'PaymentEvent',
            'PaymentMandate',
            'PaymentMandate_nextV1',
            'PaymentRecommendation',
            'PaymentSchedule',
            'PaymentSchedule_nextV1',
            'PaymentTransaction',
            'PaymentV3',
            'ProductVersion',
            'PropertySupplyPoint',
            'SupplyAgentSearchQueryResult',
            'SupplyPoint',
            'TariffTimingConfiguration',
            'Tariff_nextV1',
            'TransactionType_nextV1',
            'ValidReading',
        ],
        ProductDeviceCharge: ['ProductConsumptionCharge', 'ProductDailyCharge'],
        StartMigrationError: [
            'InvalidInputError',
            'SystemError',
            'UnauthorizedError',
        ],
        SupplyPointData: ['SupplyPoint'],
        TimingCategoryConsumptionCharge: [
            'ElectricityConsumptionCharge',
            'GasConsumptionCharge',
        ],
        Total: ['NonTaxableTotal', 'TaxableTotal'],
        Transaction: ['NonTaxableTransaction', 'TaxableTransaction'],
        ValidatedRead: ['InValidReading', 'ValidReading'],
    },
};
exports.default = result;
/** Values for the status of comms and statement events. */
var AccountEventSentStatus;
(function (AccountEventSentStatus) {
    AccountEventSentStatus["Delivered"] = "DELIVERED";
    AccountEventSentStatus["Failed"] = "FAILED";
})(AccountEventSentStatus || (exports.AccountEventSentStatus = AccountEventSentStatus = {}));
/** Types of retailer events accepted. */
var AccountEventType;
(function (AccountEventType) {
    AccountEventType["Comm"] = "COMM";
    AccountEventType["Generic"] = "GENERIC";
    AccountEventType["Memo"] = "MEMO";
    AccountEventType["Statement"] = "STATEMENT";
})(AccountEventType || (exports.AccountEventType = AccountEventType = {}));
/** The type of account reference provided */
var AccountReferenceType;
(function (AccountReferenceType) {
    AccountReferenceType["AccountId"] = "ACCOUNT_ID";
    AccountReferenceType["AccountNumber"] = "ACCOUNT_NUMBER";
    AccountReferenceType["OeaBpayReference"] = "OEA_BPAY_REFERENCE";
})(AccountReferenceType || (exports.AccountReferenceType = AccountReferenceType = {}));
/** The values for the type of the action. */
var ActionType;
(function (ActionType) {
    ActionType["Assigned"] = "ASSIGNED";
    ActionType["Created"] = "CREATED";
    ActionType["StatusUpdate"] = "STATUS_UPDATE";
    ActionType["Unassigned"] = "UNASSIGNED";
})(ActionType || (exports.ActionType = ActionType = {}));
/** A list displaying the criteria on which the discount is calculated. */
var ApplicabilityCalculatedOn;
(function (ApplicabilityCalculatedOn) {
    ApplicabilityCalculatedOn["Annually"] = "ANNUALLY";
    ApplicabilityCalculatedOn["Daily"] = "DAILY";
    ApplicabilityCalculatedOn["EnergyCharges"] = "ENERGY_CHARGES";
    ApplicabilityCalculatedOn["EnergyChargesAndSupplyCosts"] = "ENERGY_CHARGES_AND_SUPPLY_COSTS";
})(ApplicabilityCalculatedOn || (exports.ApplicabilityCalculatedOn = ApplicabilityCalculatedOn = {}));
/** The types of days that this period applies to. These are either days of the week or holiday days. */
var ApplicableDay;
(function (ApplicableDay) {
    ApplicableDay["Fri"] = "FRI";
    ApplicableDay["Holiday"] = "HOLIDAY";
    ApplicableDay["Mon"] = "MON";
    ApplicableDay["Sat"] = "SAT";
    ApplicableDay["Sun"] = "SUN";
    ApplicableDay["Thu"] = "THU";
    ApplicableDay["Tue"] = "TUE";
    ApplicableDay["Wed"] = "WED";
})(ApplicableDay || (exports.ApplicableDay = ApplicableDay = {}));
/** A list of appointment time windows, representing a 5 hour window of time. */
var AppointmentTimeWindow;
(function (AppointmentTimeWindow) {
    AppointmentTimeWindow["Appt_08To_13"] = "APPT_08_TO_13";
    AppointmentTimeWindow["Appt_09To_14"] = "APPT_09_TO_14";
    AppointmentTimeWindow["Appt_10To_15"] = "APPT_10_TO_15";
    AppointmentTimeWindow["Appt_11To_16"] = "APPT_11_TO_16";
    AppointmentTimeWindow["Appt_12To_17"] = "APPT_12_TO_17";
    AppointmentTimeWindow["Appt_13To_18"] = "APPT_13_TO_18";
})(AppointmentTimeWindow || (exports.AppointmentTimeWindow = AppointmentTimeWindow = {}));
/** The categorisation of transaction-type given how it affects a balance. */
var BalanceCategory;
(function (BalanceCategory) {
    BalanceCategory["Charges"] = "CHARGES";
    BalanceCategory["Discounts"] = "DISCOUNTS";
    BalanceCategory["Payments"] = "PAYMENTS";
    BalanceCategory["Refunds"] = "REFUNDS";
})(BalanceCategory || (exports.BalanceCategory = BalanceCategory = {}));
/** The frequency preference. */
var BillFrequencyType;
(function (BillFrequencyType) {
    BillFrequencyType["Annually"] = "ANNUALLY";
    BillFrequencyType["BiMonthly"] = "BI_MONTHLY";
    BillFrequencyType["Monthly"] = "MONTHLY";
    BillFrequencyType["Quarterly"] = "QUARTERLY";
})(BillFrequencyType || (exports.BillFrequencyType = BillFrequencyType = {}));
/** Generated bill type. */
var BillType;
(function (BillType) {
    BillType["Draft"] = "DRAFT";
    BillType["Final"] = "FINAL";
    BillType["InLife"] = "IN_LIFE";
    BillType["OnDemand"] = "ON_DEMAND";
})(BillType || (exports.BillType = BillType = {}));
/** The time window over which consumption is summed for block tariffs, before applying thresholds to determine the unit rate. */
var BlockRateAccountingWindow;
(function (BlockRateAccountingWindow) {
    BlockRateAccountingWindow["Day"] = "DAY";
    BlockRateAccountingWindow["None"] = "NONE";
    BlockRateAccountingWindow["Other"] = "OTHER";
})(BlockRateAccountingWindow || (exports.BlockRateAccountingWindow = BlockRateAccountingWindow = {}));
/** The card scheme used for a card payment */
var CardScheme;
(function (CardScheme) {
    CardScheme["Amex"] = "AMEX";
    CardScheme["Diners"] = "DINERS";
    CardScheme["EftposAus"] = "EFTPOS_AUS";
    CardScheme["Jcb"] = "JCB";
    CardScheme["Mastercard"] = "MASTERCARD";
    CardScheme["Unionpay"] = "UNIONPAY";
    CardScheme["Visa"] = "VISA";
})(CardScheme || (exports.CardScheme = CardScheme = {}));
/** A list of the charging pipelines which are the source of the energy charges. */
var ChargingPipeline;
(function (ChargingPipeline) {
    /** The current daily estimate charging pipeline. */
    ChargingPipeline["Daily"] = "DAILY";
    /** The legacy variable length charging pipeline. */
    ChargingPipeline["Variable"] = "VARIABLE";
})(ChargingPipeline || (exports.ChargingPipeline = ChargingPipeline = {}));
/** The customer's preferred method to receive communications. */
var CommsPreference;
(function (CommsPreference) {
    CommsPreference["Email"] = "EMAIL";
    CommsPreference["Phone"] = "PHONE";
    CommsPreference["Post"] = "POST";
    CommsPreference["Sms"] = "SMS";
})(CommsPreference || (exports.CommsPreference = CommsPreference = {}));
/** The communications channel preferred by the customer. */
var CommunicationChannel;
(function (CommunicationChannel) {
    CommunicationChannel["Email"] = "EMAIL";
    CommunicationChannel["Phone"] = "PHONE";
    CommunicationChannel["Post"] = "POST";
    CommunicationChannel["Sms"] = "SMS";
})(CommunicationChannel || (exports.CommunicationChannel = CommunicationChannel = {}));
/** The type of comparison, e.g. if it is checking equality, within a range, or empty. */
var ComparisonType;
(function (ComparisonType) {
    ComparisonType["Array"] = "ARRAY";
    ComparisonType["Blank"] = "BLANK";
    ComparisonType["Equal"] = "EQUAL";
})(ComparisonType || (exports.ComparisonType = ComparisonType = {}));
/** The comparison logic possibilities. */
var ComparisonValue;
(function (ComparisonValue) {
    ComparisonValue["EqualTo"] = "EQUAL_TO";
    ComparisonValue["In"] = "IN";
    ComparisonValue["IsBlank"] = "IS_BLANK";
    ComparisonValue["IsDefined"] = "IS_DEFINED";
    ComparisonValue["IsNotBlank"] = "IS_NOT_BLANK";
    ComparisonValue["IsNotDefined"] = "IS_NOT_DEFINED";
    ComparisonValue["NotEqualTo"] = "NOT_EQUAL_TO";
    ComparisonValue["NotIn"] = "NOT_IN";
})(ComparisonValue || (exports.ComparisonValue = ComparisonValue = {}));
/** A list of the possible concession card types. */
var ConcessionCard;
(function (ConcessionCard) {
    ConcessionCard["HealthCare"] = "HEALTH_CARE";
    ConcessionCard["Pensioner"] = "PENSIONER";
    ConcessionCard["QueenslandSeniors"] = "QUEENSLAND_SENIORS";
    ConcessionCard["Veterans"] = "VETERANS";
})(ConcessionCard || (exports.ConcessionCard = ConcessionCard = {}));
/** The list of possible concession groups that a customer can be part of. */
var ConcessionCardType;
(function (ConcessionCardType) {
    ConcessionCardType["HealthCare"] = "HEALTH_CARE";
    ConcessionCardType["Pensioner"] = "PENSIONER";
    ConcessionCardType["QueenslandSeniors"] = "QUEENSLAND_SENIORS";
    ConcessionCardType["Veterans"] = "VETERANS";
})(ConcessionCardType || (exports.ConcessionCardType = ConcessionCardType = {}));
/** A list of the regions to which the concession could apply. */
var ConcessionRegion;
(function (ConcessionRegion) {
    ConcessionRegion["AustralianCapitalTerritory"] = "AUSTRALIAN_CAPITAL_TERRITORY";
    ConcessionRegion["NewSouthWales"] = "NEW_SOUTH_WALES";
    ConcessionRegion["Queensland"] = "QUEENSLAND";
    ConcessionRegion["SouthAustralia"] = "SOUTH_AUSTRALIA";
    ConcessionRegion["Victoria"] = "VICTORIA";
})(ConcessionRegion || (exports.ConcessionRegion = ConcessionRegion = {}));
/** The level of consent, for example HALF_HOURLY would consent to Half Hourly read data to be used. */
var ConsentLevel;
(function (ConsentLevel) {
    ConsentLevel["Daily"] = "DAILY";
    ConsentLevel["HalfHourly"] = "HALF_HOURLY";
    ConsentLevel["Monthly"] = "MONTHLY";
})(ConsentLevel || (exports.ConsentLevel = ConsentLevel = {}));
/**
 * The type of consent given. EXPLICIT would indicate explicit consent has be received from the customer.
 * DEFAULT would indicate that the customer has not opted-out within the notice period.
 */
var ConsentType;
(function (ConsentType) {
    ConsentType["Default"] = "DEFAULT";
    ConsentType["Explicit"] = "EXPLICIT";
})(ConsentType || (exports.ConsentType = ConsentType = {}));
/** A list of the available units of measure used to record gas readings. */
var ConsumptionChargeGasUnitOfMeasurement;
(function (ConsumptionChargeGasUnitOfMeasurement) {
    /** 100 cubic feet. */
    ConsumptionChargeGasUnitOfMeasurement["Ccf"] = "CCF";
    /** Megajoules. */
    ConsumptionChargeGasUnitOfMeasurement["Mj"] = "MJ";
})(ConsumptionChargeGasUnitOfMeasurement || (exports.ConsumptionChargeGasUnitOfMeasurement = ConsumptionChargeGasUnitOfMeasurement = {}));
/** Reasons for contracts ending. */
var ContractEndEventReason;
(function (ContractEndEventReason) {
    ContractEndEventReason["Loss"] = "LOSS";
    ContractEndEventReason["MoveOut"] = "MOVE_OUT";
    ContractEndEventReason["Other"] = "OTHER";
    ContractEndEventReason["PaymentMethodChangeToDirectDebit"] = "PAYMENT_METHOD_CHANGE_TO_DIRECT_DEBIT";
    ContractEndEventReason["PaymentMethodChangeToOnDemand"] = "PAYMENT_METHOD_CHANGE_TO_ON_DEMAND";
    ContractEndEventReason["Refixed"] = "REFIXED";
    ContractEndEventReason["RegionSwitched"] = "REGION_SWITCHED";
    ContractEndEventReason["Renewed"] = "RENEWED";
    ContractEndEventReason["RolledToVariable"] = "ROLLED_TO_VARIABLE";
    ContractEndEventReason["TariffHop"] = "TARIFF_HOP";
    ContractEndEventReason["Unknown"] = "UNKNOWN";
})(ContractEndEventReason || (exports.ContractEndEventReason = ContractEndEventReason = {}));
/** Reasons for contracts starting. */
var ContractStartEventReason;
(function (ContractStartEventReason) {
    ContractStartEventReason["Migrated"] = "MIGRATED";
    ContractStartEventReason["MoveIn"] = "MOVE_IN";
    ContractStartEventReason["Other"] = "OTHER";
    ContractStartEventReason["PaymentMethodChangeToDirectDebit"] = "PAYMENT_METHOD_CHANGE_TO_DIRECT_DEBIT";
    ContractStartEventReason["PaymentMethodChangeToOnDemand"] = "PAYMENT_METHOD_CHANGE_TO_ON_DEMAND";
    ContractStartEventReason["Refixed"] = "REFIXED";
    ContractStartEventReason["RegionSwitched"] = "REGION_SWITCHED";
    ContractStartEventReason["Renewed"] = "RENEWED";
    ContractStartEventReason["RolledToVariable"] = "ROLLED_TO_VARIABLE";
    ContractStartEventReason["TariffHop"] = "TARIFF_HOP";
    ContractStartEventReason["Unknown"] = "UNKNOWN";
})(ContractStartEventReason || (exports.ContractStartEventReason = ContractStartEventReason = {}));
/** Reasons for the tariff changing on a contract. */
var ContractTariffEntryStartReason;
(function (ContractTariffEntryStartReason) {
    ContractTariffEntryStartReason["ContractStart"] = "CONTRACT_START";
    ContractTariffEntryStartReason["PriceChange"] = "PRICE_CHANGE";
})(ContractTariffEntryStartReason || (exports.ContractTariffEntryStartReason = ContractTariffEntryStartReason = {}));
/** The experiences that a device can be controlled through. */
var ControllableThrough;
(function (ControllableThrough) {
    /**
     * The device can be controlled through the Device Manufacturer Experience.
     * Examples of this are new Volvo vehicles, that can only be controlled through the Volvo Car App.
     */
    ControllableThrough["DeviceManufacturerExperience"] = "DEVICE_MANUFACTURER_EXPERIENCE";
    /** The device can be controlled through the Energy Retailer Experience. */
    ControllableThrough["EnergyRetailerExperience"] = "ENERGY_RETAILER_EXPERIENCE";
})(ControllableThrough || (exports.ControllableThrough = ControllableThrough = {}));
/** A list of balance statuses representing whether the balance is a negative (debit) or positive (credit) balance. */
var CreditDebitType;
(function (CreditDebitType) {
    /** The balance is positive. */
    CreditDebitType["Credit"] = "CREDIT";
    /** The balance is negative. */
    CreditDebitType["Debit"] = "DEBIT";
})(CreditDebitType || (exports.CreditDebitType = CreditDebitType = {}));
/** The currency to be used with monetary values. */
var CurrencyCode;
(function (CurrencyCode) {
    CurrencyCode["Aud"] = "AUD";
    CurrencyCode["Gbp"] = "GBP";
})(CurrencyCode || (exports.CurrencyCode = CurrencyCode = {}));
/** List of valid ISO-4217 that are accepted as input values. */
var CurrencyInput;
(function (CurrencyInput) {
    CurrencyInput["Aud"] = "AUD";
    CurrencyInput["Gbp"] = "GBP";
})(CurrencyInput || (exports.CurrencyInput = CurrencyInput = {}));
/** Role for a customer against an account. */
var CustomerAccountRole;
(function (CustomerAccountRole) {
    CustomerAccountRole["FinanciallyLiable"] = "FINANCIALLY_LIABLE";
    CustomerAccountRole["PrimaryCustomer"] = "PRIMARY_CUSTOMER";
})(CustomerAccountRole || (exports.CustomerAccountRole = CustomerAccountRole = {}));
/** Information about the role assigned to a customer against an account. */
var CustomerAccountRole_NextV1;
(function (CustomerAccountRole_NextV1) {
    /** This is used to indicate that the attached customer is a victim of domestic violence. */
    CustomerAccountRole_NextV1["DomesticViolence"] = "DOMESTIC_VIOLENCE";
    /**
     * This denotes the customer is financially responsible for payment on the account.
     * This has no bearing on access to payment related capability within the extended platform such as amending the payment instruction. This is restricted to customers that have a relationship with the relevant payment mandate.
     */
    CustomerAccountRole_NextV1["FinanciallyLiable"] = "FINANCIALLY_LIABLE";
    /** This is used to indicate that the attached customer is a landlord. */
    CustomerAccountRole_NextV1["Landlord"] = "LANDLORD";
    /** This is used to indicate that the attached customer is not eligible for a refund after a final bill. */
    CustomerAccountRole_NextV1["NoRefund"] = "NO_REFUND";
    /** This is used to indicate that the attached customer is a partner. */
    CustomerAccountRole_NextV1["Partner"] = "PARTNER";
    /** This is used to indicate that the attached customer is eligible to act on behalf of the primary account holder. */
    CustomerAccountRole_NextV1["PowerOfAttorney"] = "POWER_OF_ATTORNEY";
})(CustomerAccountRole_NextV1 || (exports.CustomerAccountRole_NextV1 = CustomerAccountRole_NextV1 = {}));
/** A list of customer statuses, representing whether the customer is active or deceased. */
var CustomerStatus;
(function (CustomerStatus) {
    CustomerStatus["Active"] = "ACTIVE";
    CustomerStatus["Deceased"] = "DECEASED";
})(CustomerStatus || (exports.CustomerStatus = CustomerStatus = {}));
/** The possible titles for a customer. */
var CustomerTitle;
(function (CustomerTitle) {
    CustomerTitle["Dr"] = "DR";
    CustomerTitle["Lady"] = "LADY";
    CustomerTitle["Lord"] = "LORD";
    CustomerTitle["Miss"] = "MISS";
    CustomerTitle["Mr"] = "MR";
    CustomerTitle["Mrs"] = "MRS";
    CustomerTitle["Ms"] = "MS";
    CustomerTitle["Mx"] = "MX";
    CustomerTitle["Prof"] = "PROF";
    CustomerTitle["Rev"] = "REV";
    CustomerTitle["Sir"] = "SIR";
})(CustomerTitle || (exports.CustomerTitle = CustomerTitle = {}));
/** Indicates whether the customer account is a business or residential account. */
var CustomerType;
(function (CustomerType) {
    CustomerType["Commercial"] = "COMMERCIAL";
    CustomerType["Residential"] = "RESIDENTIAL";
})(CustomerType || (exports.CustomerType = CustomerType = {}));
/** The time window over which consumption will be examined to find the period of peak demand, to apply a demand charge. */
var DemandRateAccountingWindow;
(function (DemandRateAccountingWindow) {
    DemandRateAccountingWindow["CalendarMonth"] = "CALENDAR_MONTH";
    DemandRateAccountingWindow["Other"] = "OTHER";
})(DemandRateAccountingWindow || (exports.DemandRateAccountingWindow = DemandRateAccountingWindow = {}));
/** Available device types. */
var DeviceType;
(function (DeviceType) {
    DeviceType["ElectricVehicle"] = "ELECTRIC_VEHICLE";
    DeviceType["ElectricVehicleCharger"] = "ELECTRIC_VEHICLE_CHARGER";
    DeviceType["SolarInverter"] = "SOLAR_INVERTER";
})(DeviceType || (exports.DeviceType = DeviceType = {}));
/** The reason why power is not flowing through the vehicle. */
var ElectricVehicleNoPowerTransferReason;
(function (ElectricVehicleNoPowerTransferReason) {
    /** A cable is connected to the vehicle, but is currently inactive. */
    ElectricVehicleNoPowerTransferReason["CableConnectedNoPowerDelivery"] = "CABLE_CONNECTED_NO_POWER_DELIVERY";
    /** Power is not flowing through the vehicle due to the cable being disconnected. */
    ElectricVehicleNoPowerTransferReason["CableDisconnected"] = "CABLE_DISCONNECTED";
    /** Power is not flowing through the vehicle due to an issue with the cable. */
    ElectricVehicleNoPowerTransferReason["CableFault"] = "CABLE_FAULT";
    /** Power is not flowing through the vehicle for an unknown reason. */
    ElectricVehicleNoPowerTransferReason["Unknown"] = "UNKNOWN";
})(ElectricVehicleNoPowerTransferReason || (exports.ElectricVehicleNoPowerTransferReason = ElectricVehicleNoPowerTransferReason = {}));
/** The reason that we are not in control of this electric vehicle. */
var ElectricVehicleNotUnderControlReason;
(function (ElectricVehicleNotUnderControlReason) {
    /**
     * The vehicle is away from its registered home location.
     *
     * At Kaluza we manage at-home smart charging. If the vehicle is away from home, then this is outside the scope of our product offering.
     */
    ElectricVehicleNotUnderControlReason["AwayFromHome"] = "AWAY_FROM_HOME";
    /**
     * The user's credentials are invalid. This typically occurs when the user has revoked Kaluza's access to the device.
     *
     * !!!! WARNING !!!! This field is unstable and likely to be replaced.
     */
    ElectricVehicleNotUnderControlReason["HasInvalidCredentials"] = "HAS_INVALID_CREDENTIALS";
    /** An internal fault in the Kaluza platform. */
    ElectricVehicleNotUnderControlReason["InternalFault"] = "INTERNAL_FAULT";
    /**
     * Kaluza platform has yet to receive telemetry from the vehicle.
     *
     * Whilst we may have successfully onboarded the vehicle, without telemetry many of the Kaluza platform's smart charging capabilities will not be available.
     *
     * This state may represent that there is an issue receiving telemetry from the vehicle that needs to be investigated, or it may be that the vehicle has been recently onboarded and the Kaluza platform is awaiting the first data to be received.
     */
    ElectricVehicleNotUnderControlReason["NoTelemetry"] = "NO_TELEMETRY";
    /** The user has linked this device, but has not enabled smart charging. */
    ElectricVehicleNotUnderControlReason["SmartChargingDisabled"] = "SMART_CHARGING_DISABLED";
})(ElectricVehicleNotUnderControlReason || (exports.ElectricVehicleNotUnderControlReason = ElectricVehicleNotUnderControlReason = {}));
/**
 * A list of all of the possible optimisation modes for a vehicle.
 *
 * Different optimisation modes prioritise different aspects of charging such as reaching a target battery percentage at a particular time, or only charging during certain periods.
 */
var ElectricVehicleOptimisationMode;
(function (ElectricVehicleOptimisationMode) {
    /**
     * Ready by time.
     *
     * Ready by time based optimisation is used to ensure that a vehicle has reached its target battery percentage by a certain time of day.
     *
     * This form of optimisation mode is typically employed by vehicles on a single-rate tariff.
     */
    ElectricVehicleOptimisationMode["ReadyByTime"] = "READY_BY_TIME";
})(ElectricVehicleOptimisationMode || (exports.ElectricVehicleOptimisationMode = ElectricVehicleOptimisationMode = {}));
/** The type of power transfer in or out of the vehicle. */
var ElectricVehiclePowerTransferType;
(function (ElectricVehiclePowerTransferType) {
    /** The vehicle is importing power via Kaluza Smart Charging. */
    ElectricVehiclePowerTransferType["ImportSmartCharge"] = "IMPORT_SMART_CHARGE";
    /** The vehicle is importing power via a user-initiated urgent charge. */
    ElectricVehiclePowerTransferType["ImportUrgentCharge"] = "IMPORT_URGENT_CHARGE";
})(ElectricVehiclePowerTransferType || (exports.ElectricVehiclePowerTransferType = ElectricVehiclePowerTransferType = {}));
/** Available vehicle types. */
var ElectricVehicleType;
(function (ElectricVehicleType) {
    ElectricVehicleType["BatteryElectricVehicle"] = "BATTERY_ELECTRIC_VEHICLE";
    ElectricVehicleType["PlugInHybridElectricVehicle"] = "PLUG_IN_HYBRID_ELECTRIC_VEHICLE";
    ElectricVehicleType["Unknown"] = "UNKNOWN";
})(ElectricVehicleType || (exports.ElectricVehicleType = ElectricVehicleType = {}));
/** A list of the possible energisation statuses of a supply point. */
var EnergisationStatus;
(function (EnergisationStatus) {
    EnergisationStatus["Deenergised"] = "DEENERGISED";
    EnergisationStatus["Energised"] = "ENERGISED";
})(EnergisationStatus || (exports.EnergisationStatus = EnergisationStatus = {}));
/** The type of consent obtained from the customer. */
var EnergyAcquisitionConsentType_V0Migration;
(function (EnergyAcquisitionConsentType_V0Migration) {
    EnergyAcquisitionConsentType_V0Migration["Default"] = "DEFAULT";
    EnergyAcquisitionConsentType_V0Migration["Explicit"] = "EXPLICIT";
})(EnergyAcquisitionConsentType_V0Migration || (exports.EnergyAcquisitionConsentType_V0Migration = EnergyAcquisitionConsentType_V0Migration = {}));
/** The list of possible critical codes. */
var EnergyAcquisitionCriticalCode_V0Migration;
(function (EnergyAcquisitionCriticalCode_V0Migration) {
    EnergyAcquisitionCriticalCode_V0Migration["Aged60Plus"] = "Aged60Plus";
    EnergyAcquisitionCriticalCode_V0Migration["ArthriticAll"] = "ArthriticAll";
    EnergyAcquisitionCriticalCode_V0Migration["ArthriticHands"] = "ArthriticHands";
    EnergyAcquisitionCriticalCode_V0Migration["Bedridden"] = "Bedridden";
    EnergyAcquisitionCriticalCode_V0Migration["Blind"] = "Blind";
    EnergyAcquisitionCriticalCode_V0Migration["BrailleUser"] = "BrailleUser";
    EnergyAcquisitionCriticalCode_V0Migration["BreathingDifficulty"] = "BreathingDifficulty";
    EnergyAcquisitionCriticalCode_V0Migration["Deaf"] = "Deaf";
    EnergyAcquisitionCriticalCode_V0Migration["Dementia"] = "Dementia";
    EnergyAcquisitionCriticalCode_V0Migration["HeartCondition"] = "HeartCondition";
    EnergyAcquisitionCriticalCode_V0Migration["MentalHandicap"] = "MentalHandicap";
    EnergyAcquisitionCriticalCode_V0Migration["Other"] = "Other";
    EnergyAcquisitionCriticalCode_V0Migration["PoorHearing"] = "PoorHearing";
    EnergyAcquisitionCriticalCode_V0Migration["PoorSenseOfSmell"] = "PoorSenseOfSmell";
    EnergyAcquisitionCriticalCode_V0Migration["PoorSight"] = "PoorSight";
    EnergyAcquisitionCriticalCode_V0Migration["PoorSpeech"] = "PoorSpeech";
    EnergyAcquisitionCriticalCode_V0Migration["PoorWalking"] = "PoorWalking";
    EnergyAcquisitionCriticalCode_V0Migration["SeriousIllness"] = "SeriousIllness";
    EnergyAcquisitionCriticalCode_V0Migration["Wheelchair"] = "Wheelchair";
})(EnergyAcquisitionCriticalCode_V0Migration || (exports.EnergyAcquisitionCriticalCode_V0Migration = EnergyAcquisitionCriticalCode_V0Migration = {}));
/** The possible currency codes. */
var EnergyAcquisitionCurrencyCode_V0Migration;
(function (EnergyAcquisitionCurrencyCode_V0Migration) {
    EnergyAcquisitionCurrencyCode_V0Migration["Gbp"] = "GBP";
})(EnergyAcquisitionCurrencyCode_V0Migration || (exports.EnergyAcquisitionCurrencyCode_V0Migration = EnergyAcquisitionCurrencyCode_V0Migration = {}));
/** The possible customer account roles. */
var EnergyAcquisitionCustomerAccountRole;
(function (EnergyAcquisitionCustomerAccountRole) {
    EnergyAcquisitionCustomerAccountRole["DomesticViolence"] = "DOMESTIC_VIOLENCE";
    EnergyAcquisitionCustomerAccountRole["FinanciallyLiable"] = "FINANCIALLY_LIABLE";
    EnergyAcquisitionCustomerAccountRole["Landlord"] = "LANDLORD";
    EnergyAcquisitionCustomerAccountRole["NoRefund"] = "NO_REFUND";
    EnergyAcquisitionCustomerAccountRole["Partner"] = "PARTNER";
    EnergyAcquisitionCustomerAccountRole["PrimaryCustomer"] = "PRIMARY_CUSTOMER";
})(EnergyAcquisitionCustomerAccountRole || (exports.EnergyAcquisitionCustomerAccountRole = EnergyAcquisitionCustomerAccountRole = {}));
/** The possible customer account roles. */
var EnergyAcquisitionCustomerAccountRoleInput;
(function (EnergyAcquisitionCustomerAccountRoleInput) {
    EnergyAcquisitionCustomerAccountRoleInput["FinanciallyLiable"] = "FINANCIALLY_LIABLE";
    EnergyAcquisitionCustomerAccountRoleInput["PrimaryCustomer"] = "PRIMARY_CUSTOMER";
})(EnergyAcquisitionCustomerAccountRoleInput || (exports.EnergyAcquisitionCustomerAccountRoleInput = EnergyAcquisitionCustomerAccountRoleInput = {}));
/** The role that the customer has with the associated account, for example PRIMARY_CUSTOMER, FINANCIALLY_LIABLE, LANDLORD. */
var EnergyAcquisitionCustomerAccountRole_V0Migration;
(function (EnergyAcquisitionCustomerAccountRole_V0Migration) {
    EnergyAcquisitionCustomerAccountRole_V0Migration["FinanciallyLiable"] = "FINANCIALLY_LIABLE";
    EnergyAcquisitionCustomerAccountRole_V0Migration["Landlord"] = "LANDLORD";
    EnergyAcquisitionCustomerAccountRole_V0Migration["NoRefund"] = "NO_REFUND";
    EnergyAcquisitionCustomerAccountRole_V0Migration["Partner"] = "PARTNER";
    EnergyAcquisitionCustomerAccountRole_V0Migration["PrimaryCustomer"] = "PRIMARY_CUSTOMER";
})(EnergyAcquisitionCustomerAccountRole_V0Migration || (exports.EnergyAcquisitionCustomerAccountRole_V0Migration = EnergyAcquisitionCustomerAccountRole_V0Migration = {}));
/** The possible data preferences. */
var EnergyAcquisitionDataPreference_V0Migration;
(function (EnergyAcquisitionDataPreference_V0Migration) {
    EnergyAcquisitionDataPreference_V0Migration["Daily"] = "Daily";
    EnergyAcquisitionDataPreference_V0Migration["HalfHourly"] = "HalfHourly";
    EnergyAcquisitionDataPreference_V0Migration["Monthly"] = "Monthly";
})(EnergyAcquisitionDataPreference_V0Migration || (exports.EnergyAcquisitionDataPreference_V0Migration = EnergyAcquisitionDataPreference_V0Migration = {}));
/** A list of the possible types of identification document. */
var EnergyAcquisitionIdentificationType;
(function (EnergyAcquisitionIdentificationType) {
    EnergyAcquisitionIdentificationType["DriversLicence"] = "DRIVERS_LICENCE";
    EnergyAcquisitionIdentificationType["MedicareCard"] = "MEDICARE_CARD";
    EnergyAcquisitionIdentificationType["Passport"] = "PASSPORT";
})(EnergyAcquisitionIdentificationType || (exports.EnergyAcquisitionIdentificationType = EnergyAcquisitionIdentificationType = {}));
/** A list of possible medicare card colours. */
var EnergyAcquisitionMedicareCardColour;
(function (EnergyAcquisitionMedicareCardColour) {
    EnergyAcquisitionMedicareCardColour["Blue"] = "BLUE";
    EnergyAcquisitionMedicareCardColour["Green"] = "GREEN";
    EnergyAcquisitionMedicareCardColour["Yellow"] = "YELLOW";
})(EnergyAcquisitionMedicareCardColour || (exports.EnergyAcquisitionMedicareCardColour = EnergyAcquisitionMedicareCardColour = {}));
/** The possible meter modes. */
var EnergyAcquisitionMeterMode_V0Migration;
(function (EnergyAcquisitionMeterMode_V0Migration) {
    EnergyAcquisitionMeterMode_V0Migration["Credit"] = "Credit";
    EnergyAcquisitionMeterMode_V0Migration["PrePay"] = "PrePay";
})(EnergyAcquisitionMeterMode_V0Migration || (exports.EnergyAcquisitionMeterMode_V0Migration = EnergyAcquisitionMeterMode_V0Migration = {}));
/** The possible payment instructions. */
var EnergyAcquisitionPaymentInstruction_V0Migration;
(function (EnergyAcquisitionPaymentInstruction_V0Migration) {
    EnergyAcquisitionPaymentInstruction_V0Migration["DirectDebit"] = "DirectDebit";
    EnergyAcquisitionPaymentInstruction_V0Migration["OnDemand"] = "OnDemand";
})(EnergyAcquisitionPaymentInstruction_V0Migration || (exports.EnergyAcquisitionPaymentInstruction_V0Migration = EnergyAcquisitionPaymentInstruction_V0Migration = {}));
/** The possible payment methods. */
var EnergyAcquisitionPaymentMethod_V0Migration;
(function (EnergyAcquisitionPaymentMethod_V0Migration) {
    EnergyAcquisitionPaymentMethod_V0Migration["Payg"] = "Payg";
    EnergyAcquisitionPaymentMethod_V0Migration["Paym"] = "Paym";
})(EnergyAcquisitionPaymentMethod_V0Migration || (exports.EnergyAcquisitionPaymentMethod_V0Migration = EnergyAcquisitionPaymentMethod_V0Migration = {}));
/** The possible communication preferences. */
var EnergyAcquisitionServiceCommunicationPreference_V0Migration;
(function (EnergyAcquisitionServiceCommunicationPreference_V0Migration) {
    EnergyAcquisitionServiceCommunicationPreference_V0Migration["Email"] = "Email";
    EnergyAcquisitionServiceCommunicationPreference_V0Migration["Print"] = "Print";
    EnergyAcquisitionServiceCommunicationPreference_V0Migration["Sms"] = "SMS";
})(EnergyAcquisitionServiceCommunicationPreference_V0Migration || (exports.EnergyAcquisitionServiceCommunicationPreference_V0Migration = EnergyAcquisitionServiceCommunicationPreference_V0Migration = {}));
/** A list of the possible energy acquisition states. */
var EnergyAcquisitionState;
(function (EnergyAcquisitionState) {
    EnergyAcquisitionState["AccountSetupComplete"] = "ACCOUNT_SETUP_COMPLETE";
    EnergyAcquisitionState["AccountSetupInProgress"] = "ACCOUNT_SETUP_IN_PROGRESS";
    EnergyAcquisitionState["AccountSetupPaused"] = "ACCOUNT_SETUP_PAUSED";
    EnergyAcquisitionState["Cancelled"] = "CANCELLED";
    EnergyAcquisitionState["Complete"] = "COMPLETE";
    EnergyAcquisitionState["FailedValidation"] = "FAILED_VALIDATION";
    EnergyAcquisitionState["Received"] = "RECEIVED";
})(EnergyAcquisitionState || (exports.EnergyAcquisitionState = EnergyAcquisitionState = {}));
/** A list of the possible energy acquisition states. */
var EnergyAcquisitionState_V0Migration;
(function (EnergyAcquisitionState_V0Migration) {
    EnergyAcquisitionState_V0Migration["AccountSetupComplete"] = "ACCOUNT_SETUP_COMPLETE";
    EnergyAcquisitionState_V0Migration["AccountSetupInProgress"] = "ACCOUNT_SETUP_IN_PROGRESS";
    EnergyAcquisitionState_V0Migration["AccountSetupPaused"] = "ACCOUNT_SETUP_PAUSED";
    EnergyAcquisitionState_V0Migration["Cancelled"] = "CANCELLED";
    EnergyAcquisitionState_V0Migration["Complete"] = "COMPLETE";
    EnergyAcquisitionState_V0Migration["FailedValidation"] = "FAILED_VALIDATION";
    EnergyAcquisitionState_V0Migration["Received"] = "RECEIVED";
})(EnergyAcquisitionState_V0Migration || (exports.EnergyAcquisitionState_V0Migration = EnergyAcquisitionState_V0Migration = {}));
/** The possible tariff categories. */
var EnergyAcquisitionTariffCategory_V0Migration;
(function (EnergyAcquisitionTariffCategory_V0Migration) {
    EnergyAcquisitionTariffCategory_V0Migration["Anytime"] = "Anytime";
    EnergyAcquisitionTariffCategory_V0Migration["DomesticEconomy"] = "DomesticEconomy";
    EnergyAcquisitionTariffCategory_V0Migration["Economy7"] = "Economy7";
    EnergyAcquisitionTariffCategory_V0Migration["Economy9"] = "Economy9";
    EnergyAcquisitionTariffCategory_V0Migration["Economy10"] = "Economy10";
    EnergyAcquisitionTariffCategory_V0Migration["EconomyHeatingLoad"] = "EconomyHeatingLoad";
    EnergyAcquisitionTariffCategory_V0Migration["FlexRate"] = "FlexRate";
    EnergyAcquisitionTariffCategory_V0Migration["Heatwise2Rate"] = "Heatwise2Rate";
    EnergyAcquisitionTariffCategory_V0Migration["Heatwise3Rate"] = "Heatwise3Rate";
    EnergyAcquisitionTariffCategory_V0Migration["RegionSpecific"] = "RegionSpecific";
    EnergyAcquisitionTariffCategory_V0Migration["Superdeal"] = "Superdeal";
    EnergyAcquisitionTariffCategory_V0Migration["Thtc"] = "THTC";
    EnergyAcquisitionTariffCategory_V0Migration["2Rate"] = "_2Rate";
    EnergyAcquisitionTariffCategory_V0Migration["2RateHeating"] = "_2RateHeating";
    EnergyAcquisitionTariffCategory_V0Migration["3Rate"] = "_3Rate";
    EnergyAcquisitionTariffCategory_V0Migration["3RateEwHeating"] = "_3RateEWHeating";
    EnergyAcquisitionTariffCategory_V0Migration["3RateHeating"] = "_3RateHeating";
    EnergyAcquisitionTariffCategory_V0Migration["4Rate"] = "_4Rate";
})(EnergyAcquisitionTariffCategory_V0Migration || (exports.EnergyAcquisitionTariffCategory_V0Migration = EnergyAcquisitionTariffCategory_V0Migration = {}));
/** A list of the possible titles for a customer. */
var EnergyAcquisitionTitle;
(function (EnergyAcquisitionTitle) {
    EnergyAcquisitionTitle["Dr"] = "DR";
    EnergyAcquisitionTitle["Lady"] = "LADY";
    EnergyAcquisitionTitle["Miss"] = "MISS";
    EnergyAcquisitionTitle["Mr"] = "MR";
    EnergyAcquisitionTitle["Mrs"] = "MRS";
    EnergyAcquisitionTitle["Ms"] = "MS";
    EnergyAcquisitionTitle["Mx"] = "MX";
    EnergyAcquisitionTitle["Prof"] = "PROF";
    EnergyAcquisitionTitle["Rev"] = "REV";
    EnergyAcquisitionTitle["Sir"] = "SIR";
})(EnergyAcquisitionTitle || (exports.EnergyAcquisitionTitle = EnergyAcquisitionTitle = {}));
/** The possible titles for a customer. */
var EnergyAcquisitionTitle_V0Migration;
(function (EnergyAcquisitionTitle_V0Migration) {
    EnergyAcquisitionTitle_V0Migration["Dr"] = "Dr";
    EnergyAcquisitionTitle_V0Migration["Lady"] = "Lady";
    EnergyAcquisitionTitle_V0Migration["Miss"] = "Miss";
    EnergyAcquisitionTitle_V0Migration["Mr"] = "Mr";
    EnergyAcquisitionTitle_V0Migration["Mrs"] = "Mrs";
    EnergyAcquisitionTitle_V0Migration["Ms"] = "Ms";
    EnergyAcquisitionTitle_V0Migration["Mx"] = "Mx";
    EnergyAcquisitionTitle_V0Migration["Prof"] = "Prof";
    EnergyAcquisitionTitle_V0Migration["Rev"] = "Rev";
    EnergyAcquisitionTitle_V0Migration["Sir"] = "Sir";
})(EnergyAcquisitionTitle_V0Migration || (exports.EnergyAcquisitionTitle_V0Migration = EnergyAcquisitionTitle_V0Migration = {}));
/** The unit of measurement. */
var EnergyUnitOfMeasurement;
(function (EnergyUnitOfMeasurement) {
    EnergyUnitOfMeasurement["Kwh"] = "KWH";
})(EnergyUnitOfMeasurement || (exports.EnergyUnitOfMeasurement = EnergyUnitOfMeasurement = {}));
/** A list of the types of retailer events. */
var EventType;
(function (EventType) {
    EventType["AuditBalanceTransfer"] = "AUDIT_BALANCE_TRANSFER";
    EventType["AuditCancelHomemovesOut"] = "AUDIT_CANCEL_HOMEMOVES_OUT";
    EventType["AuditGeneric"] = "AUDIT_GENERIC";
    EventType["Comms"] = "COMMS";
    EventType["ManagedExceptionStatusChange"] = "MANAGED_EXCEPTION_STATUS_CHANGE";
    EventType["Memo"] = "MEMO";
})(EventType || (exports.EventType = EventType = {}));
/** The supply point fuel type. */
var Fuel;
(function (Fuel) {
    Fuel["Electricity"] = "Electricity";
    Fuel["Gas"] = "Gas";
})(Fuel || (exports.Fuel = Fuel = {}));
/** Possible reading source values that can appear in the result of the meter reads query. */
var FullMeterReadSource;
(function (FullMeterReadSource) {
    FullMeterReadSource["Industry"] = "INDUSTRY";
    FullMeterReadSource["ManualReadAgent"] = "MANUAL_READ_AGENT";
    FullMeterReadSource["ManualReadCustomer"] = "MANUAL_READ_CUSTOMER";
    FullMeterReadSource["Migration"] = "MIGRATION";
    FullMeterReadSource["SmartMeter"] = "SMART_METER";
})(FullMeterReadSource || (exports.FullMeterReadSource = FullMeterReadSource = {}));
/** The list of possible quality flags for a block entry. */
var IntervalFlag;
(function (IntervalFlag) {
    IntervalFlag["Actual"] = "ACTUAL";
    IntervalFlag["Estimate"] = "ESTIMATE";
    IntervalFlag["NullValue"] = "NULL_VALUE";
    IntervalFlag["Replacement"] = "REPLACEMENT";
})(IntervalFlag || (exports.IntervalFlag = IntervalFlag = {}));
/** Possible power flow types. */
var IntervalPowerFlow;
(function (IntervalPowerFlow) {
    IntervalPowerFlow["Export"] = "EXPORT";
    IntervalPowerFlow["Import"] = "IMPORT";
    IntervalPowerFlow["ImportExport"] = "IMPORT_EXPORT";
})(IntervalPowerFlow || (exports.IntervalPowerFlow = IntervalPowerFlow = {}));
/** Allowed regions in kapi. */
var KaluzaPlatformRegion;
(function (KaluzaPlatformRegion) {
    KaluzaPlatformRegion["Ap1"] = "AP1";
    KaluzaPlatformRegion["Eu1"] = "EU1";
})(KaluzaPlatformRegion || (exports.KaluzaPlatformRegion = KaluzaPlatformRegion = {}));
/** Displays whether the amount is negative (debit) or positive (credit). */
var LedgerCreditDebitType;
(function (LedgerCreditDebitType) {
    LedgerCreditDebitType["Credit"] = "CREDIT";
    LedgerCreditDebitType["Debit"] = "DEBIT";
})(LedgerCreditDebitType || (exports.LedgerCreditDebitType = LedgerCreditDebitType = {}));
/** A list displaying the possible life support equipment types. */
var LifeSupportEquipmentType;
(function (LifeSupportEquipmentType) {
    LifeSupportEquipmentType["ChronicPositiveAirwaysPressureRespirator"] = "CHRONIC_POSITIVE_AIRWAYS_PRESSURE_RESPIRATOR";
    LifeSupportEquipmentType["CriglerNajjarSyndromePhototherapyEquipment"] = "CRIGLER_NAJJAR_SYNDROME_PHOTOTHERAPY_EQUIPMENT";
    LifeSupportEquipmentType["ExternalFeedingPump"] = "EXTERNAL_FEEDING_PUMP";
    LifeSupportEquipmentType["ExternalHeartPump"] = "EXTERNAL_HEART_PUMP";
    LifeSupportEquipmentType["HomeDialysisMachine"] = "HOME_DIALYSIS_MACHINE";
    LifeSupportEquipmentType["IntermittentPeritonealDialysisMachine"] = "INTERMITTENT_PERITONEAL_DIALYSIS_MACHINE";
    LifeSupportEquipmentType["KidneyDialysisMachine"] = "KIDNEY_DIALYSIS_MACHINE";
    LifeSupportEquipmentType["Other"] = "OTHER";
    LifeSupportEquipmentType["OxygenConcentrator"] = "OXYGEN_CONCENTRATOR";
    LifeSupportEquipmentType["PowerWheelchair"] = "POWER_WHEELCHAIR";
    LifeSupportEquipmentType["TotalParentalNutritionPump"] = "TOTAL_PARENTAL_NUTRITION_PUMP";
    LifeSupportEquipmentType["Ventilator"] = "VENTILATOR";
})(LifeSupportEquipmentType || (exports.LifeSupportEquipmentType = LifeSupportEquipmentType = {}));
/** A list displaying the possible life support protection registration states. */
var LifeSupportProtectionStatus;
(function (LifeSupportProtectionStatus) {
    LifeSupportProtectionStatus["Confirmed"] = "CONFIRMED";
    LifeSupportProtectionStatus["Created"] = "CREATED";
    LifeSupportProtectionStatus["Deregistered"] = "DEREGISTERED";
    LifeSupportProtectionStatus["Registered"] = "REGISTERED";
})(LifeSupportProtectionStatus || (exports.LifeSupportProtectionStatus = LifeSupportProtectionStatus = {}));
/** Possible assignment actions for assigning a managed exception. */
var ManagedExceptionAssignmentAction;
(function (ManagedExceptionAssignmentAction) {
    ManagedExceptionAssignmentAction["Assign"] = "ASSIGN";
    ManagedExceptionAssignmentAction["Unassign"] = "UNASSIGN";
})(ManagedExceptionAssignmentAction || (exports.ManagedExceptionAssignmentAction = ManagedExceptionAssignmentAction = {}));
/** The values for the status of a managed exception. */
var ManagedExceptionStatus;
(function (ManagedExceptionStatus) {
    ManagedExceptionStatus["Awaiting"] = "AWAITING";
    ManagedExceptionStatus["Invalid"] = "INVALID";
    ManagedExceptionStatus["New"] = "NEW";
    ManagedExceptionStatus["Queued"] = "QUEUED";
    ManagedExceptionStatus["Resolved"] = "RESOLVED";
})(ManagedExceptionStatus || (exports.ManagedExceptionStatus = ManagedExceptionStatus = {}));
/** Represents the market sector of a supply point. */
var MarketSector;
(function (MarketSector) {
    MarketSector["Commercial"] = "COMMERCIAL";
    MarketSector["Domestic"] = "DOMESTIC";
    MarketSector["Nondomestic"] = "NONDOMESTIC";
})(MarketSector || (exports.MarketSector = MarketSector = {}));
/** A list showing the types of force read behaviour: hard, soft, no_force. */
var MeterReadForceType;
(function (MeterReadForceType) {
    MeterReadForceType["Hard"] = "HARD";
    MeterReadForceType["NoForce"] = "NO_FORCE";
    MeterReadForceType["Soft"] = "SOFT";
})(MeterReadForceType || (exports.MeterReadForceType = MeterReadForceType = {}));
/** Possible reading source values that can be used in the input of the mutation. */
var MeterReadSource;
(function (MeterReadSource) {
    MeterReadSource["ManualReadAgent"] = "MANUAL_READ_AGENT";
    MeterReadSource["ManualReadCustomer"] = "MANUAL_READ_CUSTOMER";
    MeterReadSource["Migration"] = "MIGRATION";
})(MeterReadSource || (exports.MeterReadSource = MeterReadSource = {}));
/** The status of the meter. */
var MeterStatus;
(function (MeterStatus) {
    MeterStatus["Active"] = "ACTIVE";
    MeterStatus["Deenergised"] = "DEENERGISED";
    MeterStatus["Removed"] = "REMOVED";
    MeterStatus["Unknown"] = "UNKNOWN";
})(MeterStatus || (exports.MeterStatus = MeterStatus = {}));
/** The status of a backfill request, where SUCCEEDED and ROLLED_BACK are terminal states. */
var MigrationBackfillRequestStatus;
(function (MigrationBackfillRequestStatus) {
    MigrationBackfillRequestStatus["Accepted"] = "ACCEPTED";
    MigrationBackfillRequestStatus["Failed"] = "FAILED";
    MigrationBackfillRequestStatus["InProgress"] = "IN_PROGRESS";
    MigrationBackfillRequestStatus["RolledBack"] = "ROLLED_BACK";
    MigrationBackfillRequestStatus["Succeeded"] = "SUCCEEDED";
})(MigrationBackfillRequestStatus || (exports.MigrationBackfillRequestStatus = MigrationBackfillRequestStatus = {}));
/**
 * A list of the status values for the backfilling of legacy billing periods.
 *
 * ## Status description
 *
 * | Error code | Description |
 * | ---------- | --------------------- |
 * | ACCEPTED | The backfill request has been accepted and queued but no action has been taken yet. |
 * | IN_PROGRESS | The data backfill is in progress, data will be partially backfilled. |
 * | SUCCEEDED | All data has been backfilled, the backfill request is complete. |
 * | FAILED | The backfill request encountered an error it can't recover from and will require manual intervention via a service desk request to resolve. |
 * | ROLLED_BACK | The backfill request encountered an error but was able to cleanly roll back. The account will be in the same state as before the rollback request. |
 */
var MigrationBackfillStatus;
(function (MigrationBackfillStatus) {
    MigrationBackfillStatus["Accepted"] = "ACCEPTED";
    MigrationBackfillStatus["Failed"] = "FAILED";
    MigrationBackfillStatus["InProgress"] = "IN_PROGRESS";
    MigrationBackfillStatus["RolledBack"] = "ROLLED_BACK";
    MigrationBackfillStatus["Succeeded"] = "SUCCEEDED";
})(MigrationBackfillStatus || (exports.MigrationBackfillStatus = MigrationBackfillStatus = {}));
/** A list of supported balance debt item types. */
var MigrationBalanceDebtItemType;
(function (MigrationBalanceDebtItemType) {
    MigrationBalanceDebtItemType["Energy"] = "ENERGY";
    MigrationBalanceDebtItemType["NonEnergy"] = "NON_ENERGY";
})(MigrationBalanceDebtItemType || (exports.MigrationBalanceDebtItemType = MigrationBalanceDebtItemType = {}));
/** A list of the frequency schedules with which a bill is generated for the account. */
var MigrationBillingFrequency;
(function (MigrationBillingFrequency) {
    MigrationBillingFrequency["Monthly"] = "MONTHLY";
    MigrationBillingFrequency["Quarterly"] = "QUARTERLY";
})(MigrationBillingFrequency || (exports.MigrationBillingFrequency = MigrationBillingFrequency = {}));
/** A list of the types of balance, e.g. credit, debit. */
var MigrationCreditDebitType;
(function (MigrationCreditDebitType) {
    MigrationCreditDebitType["Credit"] = "CREDIT";
    MigrationCreditDebitType["Debit"] = "DEBIT";
})(MigrationCreditDebitType || (exports.MigrationCreditDebitType = MigrationCreditDebitType = {}));
/** The list of possible customer statuses. */
var MigrationCustomerStatus;
(function (MigrationCustomerStatus) {
    MigrationCustomerStatus["Active"] = "ACTIVE";
    MigrationCustomerStatus["Deceased"] = "DECEASED";
})(MigrationCustomerStatus || (exports.MigrationCustomerStatus = MigrationCustomerStatus = {}));
/** The list of supported email address types. */
var MigrationEmailAddressType;
(function (MigrationEmailAddressType) {
    MigrationEmailAddressType["Contact"] = "CONTACT";
    MigrationEmailAddressType["Login"] = "LOGIN";
})(MigrationEmailAddressType || (exports.MigrationEmailAddressType = MigrationEmailAddressType = {}));
/** The payment modes of a meter. */
var MigrationMeterPaymentMode;
(function (MigrationMeterPaymentMode) {
    MigrationMeterPaymentMode["Payg"] = "PAYG";
    MigrationMeterPaymentMode["Paym"] = "PAYM";
})(MigrationMeterPaymentMode || (exports.MigrationMeterPaymentMode = MigrationMeterPaymentMode = {}));
/** Possible reading source values that are available for use in migrated meter reads. */
var MigrationMeterReadSource;
(function (MigrationMeterReadSource) {
    MigrationMeterReadSource["Industry"] = "INDUSTRY";
    MigrationMeterReadSource["ManualReadAgent"] = "MANUAL_READ_AGENT";
    MigrationMeterReadSource["ManualReadCustomer"] = "MANUAL_READ_CUSTOMER";
})(MigrationMeterReadSource || (exports.MigrationMeterReadSource = MigrationMeterReadSource = {}));
/** A list of the types of meter. */
var MigrationMeterType;
(function (MigrationMeterType) {
    MigrationMeterType["Basic"] = "BASIC";
    MigrationMeterType["Comms4"] = "COMMS4";
    MigrationMeterType["Comms4D"] = "COMMS4D";
    MigrationMeterType["Mrim"] = "MRIM";
    MigrationMeterType["Smets1"] = "SMETS1";
    MigrationMeterType["Smets2"] = "SMETS2";
    MigrationMeterType["Trad"] = "TRAD";
})(MigrationMeterType || (exports.MigrationMeterType = MigrationMeterType = {}));
/** A list of the types of meter. */
var MigrationMeterTypeEtl;
(function (MigrationMeterTypeEtl) {
    MigrationMeterTypeEtl["Basic"] = "BASIC";
    MigrationMeterTypeEtl["Comms4"] = "COMMS4";
    MigrationMeterTypeEtl["Comms4D"] = "COMMS4D";
    MigrationMeterTypeEtl["Mrim"] = "MRIM";
})(MigrationMeterTypeEtl || (exports.MigrationMeterTypeEtl = MigrationMeterTypeEtl = {}));
/** A list of the frequency schedules in which a recurring payment should be taken. */
var MigrationRecurringPaymentFrequencySchedule;
(function (MigrationRecurringPaymentFrequencySchedule) {
    MigrationRecurringPaymentFrequencySchedule["Monthly"] = "MONTHLY";
})(MigrationRecurringPaymentFrequencySchedule || (exports.MigrationRecurringPaymentFrequencySchedule = MigrationRecurringPaymentFrequencySchedule = {}));
/** A list of the statuses for a recurring payment instruction. */
var MigrationRecurringPaymentStatus;
(function (MigrationRecurringPaymentStatus) {
    MigrationRecurringPaymentStatus["Active"] = "ACTIVE";
    MigrationRecurringPaymentStatus["Failed"] = "FAILED";
    MigrationRecurringPaymentStatus["Pending"] = "PENDING";
})(MigrationRecurringPaymentStatus || (exports.MigrationRecurringPaymentStatus = MigrationRecurringPaymentStatus = {}));
/** A list of the statuses for the overall progress of a migration. */
var MigrationStatus;
(function (MigrationStatus) {
    MigrationStatus["Accepted"] = "ACCEPTED";
    MigrationStatus["Errored"] = "ERRORED";
    MigrationStatus["RolledBack"] = "ROLLED_BACK";
    MigrationStatus["Succeeded"] = "SUCCEEDED";
    MigrationStatus["TransferRequestCompleted"] = "TRANSFER_REQUEST_COMPLETED";
    MigrationStatus["TransferRequestFailed"] = "TRANSFER_REQUEST_FAILED";
    MigrationStatus["TransferRequestSent"] = "TRANSFER_REQUEST_SENT";
})(MigrationStatus || (exports.MigrationStatus = MigrationStatus = {}));
/** A list of the statuses for the stage of a migration (startMigration or completeMigration). */
var MigrationTaskStatus;
(function (MigrationTaskStatus) {
    MigrationTaskStatus["Failed"] = "FAILED";
    MigrationTaskStatus["InProgress"] = "IN_PROGRESS";
    MigrationTaskStatus["Succeeded"] = "SUCCEEDED";
})(MigrationTaskStatus || (exports.MigrationTaskStatus = MigrationTaskStatus = {}));
/** A list of supported unbilled transaction types. */
var MigrationUnbilledTransactionTypeEtl;
(function (MigrationUnbilledTransactionTypeEtl) {
    MigrationUnbilledTransactionTypeEtl["MigratedUnbilledBalanceTransferCredit"] = "MIGRATED_UNBILLED_BALANCE_TRANSFER_CREDIT";
    MigrationUnbilledTransactionTypeEtl["MigratedUnbilledBalanceTransferDebit"] = "MIGRATED_UNBILLED_BALANCE_TRANSFER_DEBIT";
    MigrationUnbilledTransactionTypeEtl["MigratedUnbilledChargeNonEnergyNonTaxable"] = "MIGRATED_UNBILLED_CHARGE_NON_ENERGY_NON_TAXABLE";
    MigrationUnbilledTransactionTypeEtl["MigratedUnbilledChargeNonEnergyTaxable"] = "MIGRATED_UNBILLED_CHARGE_NON_ENERGY_TAXABLE";
    MigrationUnbilledTransactionTypeEtl["MigratedUnbilledCreditNonTaxable"] = "MIGRATED_UNBILLED_CREDIT_NON_TAXABLE";
    MigrationUnbilledTransactionTypeEtl["MigratedUnbilledCreditTaxable"] = "MIGRATED_UNBILLED_CREDIT_TAXABLE";
    MigrationUnbilledTransactionTypeEtl["MigratedUnbilledPayment"] = "MIGRATED_UNBILLED_PAYMENT";
    MigrationUnbilledTransactionTypeEtl["MigratedUnbilledRebate"] = "MIGRATED_UNBILLED_REBATE";
    MigrationUnbilledTransactionTypeEtl["MigratedUnbilledRefund"] = "MIGRATED_UNBILLED_REFUND";
})(MigrationUnbilledTransactionTypeEtl || (exports.MigrationUnbilledTransactionTypeEtl = MigrationUnbilledTransactionTypeEtl = {}));
/** How the customer triggered this payment. */
var PaymentChannel;
(function (PaymentChannel) {
    PaymentChannel["Agent"] = "AGENT";
    PaymentChannel["DigitalBpay"] = "DIGITAL_BPAY";
    PaymentChannel["DigitalMobileApp"] = "DIGITAL_MOBILE_APP";
    PaymentChannel["DigitalMyAccount"] = "DIGITAL_MY_ACCOUNT";
    PaymentChannel["InPerson"] = "IN_PERSON";
    PaymentChannel["Ivr"] = "IVR";
    PaymentChannel["Mail"] = "MAIL";
    PaymentChannel["RecurringFixed"] = "RECURRING_FIXED";
    PaymentChannel["RecurringVariable"] = "RECURRING_VARIABLE";
})(PaymentChannel || (exports.PaymentChannel = PaymentChannel = {}));
/** The status of a payment mandate. */
var PaymentMandateStatus;
(function (PaymentMandateStatus) {
    /** This mandate is active for taking payments. */
    PaymentMandateStatus["Active"] = "ACTIVE";
    /** A payment mandate has been cancelled, so can no longer be used for taking payments. */
    PaymentMandateStatus["Cancelled"] = "CANCELLED";
    /** A PENDING request has failed. The most recent ACTIVE version of the mandate should be considered the current version. */
    PaymentMandateStatus["Failed"] = "FAILED";
    /** A request has been made to create or update a payment mandate, but the result of the request is not yet known. */
    PaymentMandateStatus["Pending"] = "PENDING";
})(PaymentMandateStatus || (exports.PaymentMandateStatus = PaymentMandateStatus = {}));
/** The status of a payment mandate. */
var PaymentMandateStatus_NextV1;
(function (PaymentMandateStatus_NextV1) {
    /** This mandate is active for taking payments. */
    PaymentMandateStatus_NextV1["Active"] = "ACTIVE";
    /** A payment mandate has been cancelled, so can no longer be used for taking payments. */
    PaymentMandateStatus_NextV1["Cancelled"] = "CANCELLED";
    /** A PENDING request has failed. The most recent ACTIVE version of the mandate should be considered the current version. */
    PaymentMandateStatus_NextV1["Failed"] = "FAILED";
    /** A request has been made to create or update a payment mandate, but the result of the request is not yet known. */
    PaymentMandateStatus_NextV1["Pending"] = "PENDING";
    /** A payment mandate has been migrated back into the previous billing system, so can no longer be used for taking payments in Kaluza. */
    PaymentMandateStatus_NextV1["ReverseMigrated"] = "REVERSE_MIGRATED";
})(PaymentMandateStatus_NextV1 || (exports.PaymentMandateStatus_NextV1 = PaymentMandateStatus_NextV1 = {}));
/** The type of payment mandate. */
var PaymentMandateType;
(function (PaymentMandateType) {
    /** A bank account was used to set up the payment mandate. */
    PaymentMandateType["BankAccount"] = "BANK_ACCOUNT";
    /** A credit or debit card was used to set up the payment mandate. */
    PaymentMandateType["Card"] = "CARD";
})(PaymentMandateType || (exports.PaymentMandateType = PaymentMandateType = {}));
/** The method used to process a payment. */
var PaymentMethod;
(function (PaymentMethod) {
    /** Payment is processed via bank account. */
    PaymentMethod["BankAccount"] = "BANK_ACCOUNT";
    /** Payment is processed via card. */
    PaymentMethod["Card"] = "CARD";
    /** Payment is processed via cheque. */
    PaymentMethod["Cheque"] = "CHEQUE";
})(PaymentMethod || (exports.PaymentMethod = PaymentMethod = {}));
/** The method used to process a payment. */
var PaymentMethodV3;
(function (PaymentMethodV3) {
    /** Payment is processed via bank account. */
    PaymentMethodV3["BankAccount"] = "BANK_ACCOUNT";
    /** Payment is processed via cash. */
    PaymentMethodV3["Cash"] = "CASH";
    /** Payment is processed via cheque. */
    PaymentMethodV3["Cheque"] = "CHEQUE";
    /** Payment is processed via credit card. */
    PaymentMethodV3["CreditCard"] = "CREDIT_CARD";
    /** Payment is processed via debit card. */
    PaymentMethodV3["DebitCard"] = "DEBIT_CARD";
    /** Payment is processed via grant. */
    PaymentMethodV3["Grant"] = "GRANT";
    /** Payment is processed via open banking. */
    PaymentMethodV3["OpenBanking"] = "OPEN_BANKING";
    /** Payment is processed via unknown card. */
    PaymentMethodV3["UnknownCard"] = "UNKNOWN_CARD";
})(PaymentMethodV3 || (exports.PaymentMethodV3 = PaymentMethodV3 = {}));
/** The status of a payment schedule. */
var PaymentScheduleStatus;
(function (PaymentScheduleStatus) {
    /** Payments can be generated by an active schedule. */
    PaymentScheduleStatus["Active"] = "ACTIVE";
    /** Payments will no longer be generated by a cancelled schedule. */
    PaymentScheduleStatus["Cancelled"] = "CANCELLED";
    /** Payments will be temporarily paused for this schedule. */
    PaymentScheduleStatus["Paused"] = "PAUSED";
})(PaymentScheduleStatus || (exports.PaymentScheduleStatus = PaymentScheduleStatus = {}));
/** The Payment Service Provider name. */
var PaymentServiceProvider;
(function (PaymentServiceProvider) {
    PaymentServiceProvider["Checkout"] = "CHECKOUT";
    PaymentServiceProvider["Finastra"] = "FINASTRA";
    PaymentServiceProvider["Gocardless"] = "GOCARDLESS";
    PaymentServiceProvider["Pol"] = "POL";
    PaymentServiceProvider["Quickstream"] = "QUICKSTREAM";
})(PaymentServiceProvider || (exports.PaymentServiceProvider = PaymentServiceProvider = {}));
/** The payment source type of the mechanism that resulted in this transaction. */
var PaymentSourceType;
(function (PaymentSourceType) {
    /** This is used for recurring or one-off payments using a bank mandate. */
    PaymentSourceType["BankAccount"] = "BANK_ACCOUNT";
    /** This is used for payments done using BPAY references. */
    PaymentSourceType["Bpay"] = "BPAY";
    /** This is used for recurring or one-off payments using a card mandate. */
    PaymentSourceType["Card"] = "CARD";
    /** This is used for payments done using Centrepay. */
    PaymentSourceType["Centrepay"] = "CENTREPAY";
    /** This is used for payments done using PayPoint. */
    PaymentSourceType["Paypoint"] = "PAYPOINT";
})(PaymentSourceType || (exports.PaymentSourceType = PaymentSourceType = {}));
/** The status of the payment transaction. */
var PaymentStatus;
(function (PaymentStatus) {
    /**
     * This indicates that a transaction should be applied to the balance.
     * A retailer controls the mapping between the transaction lifecycle in their PSP and the Kaluza transaction statuses.
     * Some retailers may choose to use a BOOKED status for a transaction that is actually PENDING, so that it is reflected on the balance as soon as possible.
     * They would then need to have a mechanism to reverse the transaction if it subsequently fails.
     * Other retailers may choose to only use a BOOKED status once the money has been settled.
     */
    PaymentStatus["Booked"] = "BOOKED";
    /**
     * An informational status. This transaction will not be applied to the account balance with a CANCELLED status.
     * This indicates that a payment was in progress but has either failed or been cancelled.
     */
    PaymentStatus["Cancelled"] = "CANCELLED";
    /**
     * An informational status. This transaction will not be applied to the account balance with a PENDING status.
     * This indicates that a payment is in progress, but may not complete.
     */
    PaymentStatus["Pending"] = "PENDING";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
/** The status of the payment transaction. */
var PaymentStatusV3;
(function (PaymentStatusV3) {
    /** This indicates that a transaction should be applied to the balance. */
    PaymentStatusV3["Booked"] = "BOOKED";
    /**
     * An informational status. This transaction will not be applied to the account balance with a FAILED status.
     * This indicates that a payment was in progress but has either failed or been cancelled.
     */
    PaymentStatusV3["Failed"] = "FAILED";
    /**
     * An informational status. This transaction will not be applied to the account balance with a PENDING status.
     * This indicates that a payment is in progress, but may not complete.
     */
    PaymentStatusV3["Pending"] = "PENDING";
    /**
     * This indicates that a transaction previously applied to the balance via a BOOKED status should be reversed.
     * An example of where this applies is a void payment tranaction which is cancelled before it is finalised or settled.
     */
    PaymentStatusV3["Reversed"] = "REVERSED";
})(PaymentStatusV3 || (exports.PaymentStatusV3 = PaymentStatusV3 = {}));
/** The type of payment based on the money movement. */
var PaymentType;
(function (PaymentType) {
    /**
     * Money moved from customer to retailer.
     * Used for recurring payments and top-up payments.
     */
    PaymentType["Payin"] = "PAYIN";
    /**
     * Money moved from retailer to customer.
     * Used for payouts and refunds.
     */
    PaymentType["Payout"] = "PAYOUT";
})(PaymentType || (exports.PaymentType = PaymentType = {}));
/** A list of the reasons for why an account and customer may be ineligible for a payout. */
var PayoutEligibilityReasonCode;
(function (PayoutEligibilityReasonCode) {
    PayoutEligibilityReasonCode["AccountInLoss"] = "ACCOUNT_IN_LOSS";
    PayoutEligibilityReasonCode["AccountNotInLoss"] = "ACCOUNT_NOT_IN_LOSS";
    PayoutEligibilityReasonCode["AccountReceivedRecentPayout"] = "ACCOUNT_RECEIVED_RECENT_PAYOUT";
    PayoutEligibilityReasonCode["BillingOnHold"] = "BILLING_ON_HOLD";
    PayoutEligibilityReasonCode["CustomerHasBereavementIndicator"] = "CUSTOMER_HAS_BEREAVEMENT_INDICATOR";
    PayoutEligibilityReasonCode["CustomerHasLandlordRole"] = "CUSTOMER_HAS_LANDLORD_ROLE";
    PayoutEligibilityReasonCode["CustomerHasNoRefundRole"] = "CUSTOMER_HAS_NO_REFUND_ROLE";
    PayoutEligibilityReasonCode["CustomerHasPartnerRole"] = "CUSTOMER_HAS_PARTNER_ROLE";
    PayoutEligibilityReasonCode["CustomerIsNotFinanciallyLiable"] = "CUSTOMER_IS_NOT_FINANCIALLY_LIABLE";
    PayoutEligibilityReasonCode["EndOfContractDebt"] = "END_OF_CONTRACT_DEBT";
    PayoutEligibilityReasonCode["InsufficientBalance"] = "INSUFFICIENT_BALANCE";
    PayoutEligibilityReasonCode["InsufficientCollectionsOnMandate"] = "INSUFFICIENT_COLLECTIONS_ON_MANDATE";
    PayoutEligibilityReasonCode["NewMandateOnAccount"] = "NEW_MANDATE_ON_ACCOUNT";
    PayoutEligibilityReasonCode["NoActiveMandate"] = "NO_ACTIVE_MANDATE";
    PayoutEligibilityReasonCode["NoFreshMeterReading"] = "NO_FRESH_METER_READING";
    PayoutEligibilityReasonCode["PayoutAlreadyRequested"] = "PAYOUT_ALREADY_REQUESTED";
    PayoutEligibilityReasonCode["RequestedAmountIsAboveMaximumLimit"] = "REQUESTED_AMOUNT_IS_ABOVE_MAXIMUM_LIMIT";
    PayoutEligibilityReasonCode["RequestedAmountIsBelowMinimumLimit"] = "REQUESTED_AMOUNT_IS_BELOW_MINIMUM_LIMIT";
})(PayoutEligibilityReasonCode || (exports.PayoutEligibilityReasonCode = PayoutEligibilityReasonCode = {}));
/** The policy name, for example BILLING_CONSENT would indicate billing consent. */
var PolicyName;
(function (PolicyName) {
    PolicyName["BillingConsent"] = "BILLING_CONSENT";
    PolicyName["SettlementConsent"] = "SETTLEMENT_CONSENT";
})(PolicyName || (exports.PolicyName = PolicyName = {}));
/** Lists the power flow of a register. */
var PowerFlow;
(function (PowerFlow) {
    PowerFlow["Export"] = "EXPORT";
    PowerFlow["Import"] = "IMPORT";
})(PowerFlow || (exports.PowerFlow = PowerFlow = {}));
/** Energy charge is for consumption or export. */
var ProductChargeType;
(function (ProductChargeType) {
    ProductChargeType["Consumption"] = "CONSUMPTION";
    ProductChargeType["Daily"] = "DAILY";
    ProductChargeType["Export"] = "EXPORT";
})(ProductChargeType || (exports.ProductChargeType = ProductChargeType = {}));
/** A list of durations for the product version, e.g. days, weeks, months, years or infinite. */
var ProductVersionDurationTimeUnit;
(function (ProductVersionDurationTimeUnit) {
    ProductVersionDurationTimeUnit["Days"] = "DAYS";
    ProductVersionDurationTimeUnit["Infinite"] = "INFINITE";
    ProductVersionDurationTimeUnit["Months"] = "MONTHS";
    ProductVersionDurationTimeUnit["Weeks"] = "WEEKS";
    ProductVersionDurationTimeUnit["Years"] = "YEARS";
})(ProductVersionDurationTimeUnit || (exports.ProductVersionDurationTimeUnit = ProductVersionDurationTimeUnit = {}));
/** A list of price units for the product version, e.g. PER_MONTH. */
var ProductVersionPriceUnit;
(function (ProductVersionPriceUnit) {
    ProductVersionPriceUnit["PerMonth"] = "PER_MONTH";
})(ProductVersionPriceUnit || (exports.ProductVersionPriceUnit = ProductVersionPriceUnit = {}));
/** The values for the type of the provenance. */
var ProvenanceType;
(function (ProvenanceType) {
    ProvenanceType["Event"] = "EVENT";
    ProvenanceType["Service"] = "SERVICE";
    ProvenanceType["User"] = "USER";
})(ProvenanceType || (exports.ProvenanceType = ProvenanceType = {}));
/** The possible optional Query Types that can be made. */
var QueryType;
(function (QueryType) {
    /** Account query, only account entities can be returned. */
    QueryType["Account"] = "ACCOUNT";
    /** Account query, only account entities can be returned, and only external IDs are used for searching. */
    QueryType["AccountExternal"] = "ACCOUNT_EXTERNAL";
    /** Customer query, only customer entities can be returned. */
    QueryType["Customer"] = "CUSTOMER";
    /** Customer query, only customer entities can be returned, and only external IDs are used for searching. */
    QueryType["CustomerExternal"] = "CUSTOMER_EXTERNAL";
    /** Generic query, any entities can be returned. */
    QueryType["Generic"] = "GENERIC";
    /** Supply query, only supply entities can be returned. */
    QueryType["Supply"] = "SUPPLY";
})(QueryType || (exports.QueryType = QueryType = {}));
/** The list of measurement units for electricity meters. */
var ReadElectricityUnitOfMeasure;
(function (ReadElectricityUnitOfMeasure) {
    ReadElectricityUnitOfMeasure["Kvah"] = "KVAH";
    ReadElectricityUnitOfMeasure["Kvarh"] = "KVARH";
    ReadElectricityUnitOfMeasure["Kwh"] = "KWH";
    ReadElectricityUnitOfMeasure["Mvah"] = "MVAH";
    ReadElectricityUnitOfMeasure["Mvarh"] = "MVARH";
    ReadElectricityUnitOfMeasure["Mwh"] = "MWH";
    ReadElectricityUnitOfMeasure["Vah"] = "VAH";
    ReadElectricityUnitOfMeasure["Varh"] = "VARH";
    ReadElectricityUnitOfMeasure["Wh"] = "WH";
})(ReadElectricityUnitOfMeasure || (exports.ReadElectricityUnitOfMeasure = ReadElectricityUnitOfMeasure = {}));
/** The list of measurement units for gas meters. */
var ReadGasUnitOfMeasure;
(function (ReadGasUnitOfMeasure) {
    ReadGasUnitOfMeasure["CubicFeet"] = "CUBIC_FEET";
    ReadGasUnitOfMeasure["CubicMetre"] = "CUBIC_METRE";
    ReadGasUnitOfMeasure["HundredCubicFeet"] = "HUNDRED_CUBIC_FEET";
})(ReadGasUnitOfMeasure || (exports.ReadGasUnitOfMeasure = ReadGasUnitOfMeasure = {}));
/** The reading lifecycle. */
var ReadLifecycle;
(function (ReadLifecycle) {
    ReadLifecycle["ChangeOfSupplyClosing"] = "CHANGE_OF_SUPPLY_CLOSING";
    ReadLifecycle["ChangeOfSupplyOpening"] = "CHANGE_OF_SUPPLY_OPENING";
    ReadLifecycle["Final"] = "FINAL";
    ReadLifecycle["Initial"] = "INITIAL";
    ReadLifecycle["Inlife"] = "INLIFE";
    ReadLifecycle["Install"] = "INSTALL";
    ReadLifecycle["Removal"] = "REMOVAL";
})(ReadLifecycle || (exports.ReadLifecycle = ReadLifecycle = {}));
/** The reading source. */
var ReadSource;
(function (ReadSource) {
    ReadSource["Industry"] = "INDUSTRY";
    ReadSource["ManualReadAgent"] = "MANUAL_READ_AGENT";
    ReadSource["ManualReadCustomer"] = "MANUAL_READ_CUSTOMER";
    ReadSource["Migration"] = "MIGRATION";
    ReadSource["SmartMeter"] = "SMART_METER";
})(ReadSource || (exports.ReadSource = ReadSource = {}));
/** The reading type. */
var ReadType;
(function (ReadType) {
    ReadType["Actual"] = "ACTUAL";
    ReadType["Estimate"] = "ESTIMATE";
})(ReadType || (exports.ReadType = ReadType = {}));
/** Possible reading lifecycle values. */
var ReadingLifecycle;
(function (ReadingLifecycle) {
    ReadingLifecycle["ChangeOfSupplyClosing"] = "CHANGE_OF_SUPPLY_CLOSING";
    ReadingLifecycle["ChangeOfSupplyOpening"] = "CHANGE_OF_SUPPLY_OPENING";
    ReadingLifecycle["Final"] = "FINAL";
    ReadingLifecycle["Initial"] = "INITIAL";
    ReadingLifecycle["Inlife"] = "INLIFE";
    ReadingLifecycle["Install"] = "INSTALL";
    ReadingLifecycle["Removal"] = "REMOVAL";
})(ReadingLifecycle || (exports.ReadingLifecycle = ReadingLifecycle = {}));
/** Possible reading type values. */
var ReadingType;
(function (ReadingType) {
    ReadingType["Actual"] = "ACTUAL";
    ReadingType["Customer"] = "CUSTOMER";
    ReadingType["Estimate"] = "ESTIMATE";
    ReadingType["Install"] = "INSTALL";
    ReadingType["Removal"] = "REMOVAL";
    ReadingType["Withdrawn"] = "WITHDRAWN";
})(ReadingType || (exports.ReadingType = ReadingType = {}));
/** Possible reading type values. */
var ReadingType_NextV1;
(function (ReadingType_NextV1) {
    ReadingType_NextV1["Actual"] = "ACTUAL";
    ReadingType_NextV1["Estimate"] = "ESTIMATE";
    ReadingType_NextV1["Withdrawn"] = "WITHDRAWN";
})(ReadingType_NextV1 || (exports.ReadingType_NextV1 = ReadingType_NextV1 = {}));
/** A list of possible recurring payment frequency periods. */
var RecurringPaymentFrequencySchedule;
(function (RecurringPaymentFrequencySchedule) {
    RecurringPaymentFrequencySchedule["Monthly"] = "MONTHLY";
})(RecurringPaymentFrequencySchedule || (exports.RecurringPaymentFrequencySchedule = RecurringPaymentFrequencySchedule = {}));
/** A list of the possible statuses of the recurring payment instruction. */
var RecurringPaymentStatus;
(function (RecurringPaymentStatus) {
    RecurringPaymentStatus["Active"] = "ACTIVE";
    RecurringPaymentStatus["Failed"] = "FAILED";
    RecurringPaymentStatus["Pending"] = "PENDING";
})(RecurringPaymentStatus || (exports.RecurringPaymentStatus = RecurringPaymentStatus = {}));
/** Payment types for recurring payments. */
var RecurringPaymentType;
(function (RecurringPaymentType) {
    RecurringPaymentType["CardMandate"] = "CARD_MANDATE";
    RecurringPaymentType["DirectDebit"] = "DIRECT_DEBIT";
})(RecurringPaymentType || (exports.RecurringPaymentType = RecurringPaymentType = {}));
/** The supported region codes. */
var RegionCode;
(function (RegionCode) {
    RegionCode["Gsp"] = "GSP";
    RegionCode["State"] = "STATE";
})(RegionCode || (exports.RegionCode = RegionCode = {}));
/** A collection of all possible region values. */
var RegionValue;
(function (RegionValue) {
    RegionValue["Nsw"] = "NSW";
    RegionValue["Qld"] = "QLD";
    RegionValue["Sa"] = "SA";
    RegionValue["Tas"] = "TAS";
    RegionValue["Vic"] = "VIC";
    RegionValue["Wa"] = "WA";
    RegionValue["A"] = "_A";
    RegionValue["B"] = "_B";
    RegionValue["C"] = "_C";
    RegionValue["D"] = "_D";
    RegionValue["E"] = "_E";
    RegionValue["F"] = "_F";
    RegionValue["G"] = "_G";
    RegionValue["H"] = "_H";
    RegionValue["J"] = "_J";
    RegionValue["K"] = "_K";
    RegionValue["L"] = "_L";
    RegionValue["M"] = "_M";
    RegionValue["N"] = "_N";
    RegionValue["P"] = "_P";
})(RegionValue || (exports.RegionValue = RegionValue = {}));
/** A list of the possible sale types. */
var SaleType;
(function (SaleType) {
    /** Where supply points are already the responsibility of the retailer. */
    SaleType["MoveIn"] = "MOVE_IN";
    /** A new customer switching to the retailer. */
    SaleType["Switch"] = "SWITCH";
})(SaleType || (exports.SaleType = SaleType = {}));
/** The possible sale types. */
var SaleType_V0Migration;
(function (SaleType_V0Migration) {
    /** A move-in and subsequent move-out. */
    SaleType_V0Migration["MoveIn"] = "MoveIn";
    /** A customer switch with SoLR configuration. */
    SaleType_V0Migration["Solr"] = "SOLR";
    /** A new customer switching to the retailer. */
    SaleType_V0Migration["Switch"] = "Switch";
})(SaleType_V0Migration || (exports.SaleType_V0Migration = SaleType_V0Migration = {}));
/** The possible sale validation statuses. */
var SaleValidationStatus_V0Migration;
(function (SaleValidationStatus_V0Migration) {
    /** The standard onboarding process is invoked. */
    SaleValidationStatus_V0Migration["Confirmed"] = "Confirmed";
    /** The acquisition is held from processing until moved to Confirmed. */
    SaleValidationStatus_V0Migration["DataVerificationRequired"] = "DataVerificationRequired";
    /** An account number is generated and the acquisition then enters the deposit payment process, the acquisition is automatically cancelled after a configured number of days in the event of non-payment. */
    SaleValidationStatus_V0Migration["DepositRequired"] = "DepositRequired";
    SaleValidationStatus_V0Migration["Unconfirmed"] = "Unconfirmed";
})(SaleValidationStatus_V0Migration || (exports.SaleValidationStatus_V0Migration = SaleValidationStatus_V0Migration = {}));
/** The frequency of a recurring payment schedule. */
var ScheduleFrequency;
(function (ScheduleFrequency) {
    /** A payment will be generated once a fortnight. */
    ScheduleFrequency["Fortnightly"] = "FORTNIGHTLY";
    /** A payment will be generated once a month. */
    ScheduleFrequency["Monthly"] = "MONTHLY";
    /** A payment will be generated once a week. */
    ScheduleFrequency["Weekly"] = "WEEKLY";
})(ScheduleFrequency || (exports.ScheduleFrequency = ScheduleFrequency = {}));
/** A list of the possible values for site hazard type. */
var SiteHazardType;
(function (SiteHazardType) {
    SiteHazardType["AsbestosBoard"] = "ASBESTOS_BOARD";
    SiteHazardType["AsbestosFuse"] = "ASBESTOS_FUSE";
    SiteHazardType["CustomerCaution"] = "CUSTOMER_CAUTION";
    SiteHazardType["CustomerReportsNoHazard"] = "CUSTOMER_REPORTS_NO_HAZARD";
    SiteHazardType["Dog"] = "DOG";
    SiteHazardType["ElectricalSafetyIssue"] = "ELECTRICAL_SAFETY_ISSUE";
    SiteHazardType["ElectricFence"] = "ELECTRIC_FENCE";
    SiteHazardType["NotKnownToInitiator"] = "NOT_KNOWN_TO_INITIATOR";
    SiteHazardType["Other"] = "OTHER";
})(SiteHazardType || (exports.SiteHazardType = SiteHazardType = {}));
/** Special communication preference for a customer. */
var SpecialCommunicationsPreference;
(function (SpecialCommunicationsPreference) {
    SpecialCommunicationsPreference["Audio"] = "AUDIO";
    SpecialCommunicationsPreference["BlackAndWhite"] = "BLACK_AND_WHITE";
    SpecialCommunicationsPreference["BlackAndWhiteLargePrint"] = "BLACK_AND_WHITE_LARGE_PRINT";
    SpecialCommunicationsPreference["Braille"] = "BRAILLE";
    SpecialCommunicationsPreference["Cd"] = "CD";
    SpecialCommunicationsPreference["LargePrint"] = "LARGE_PRINT";
    SpecialCommunicationsPreference["Welsh"] = "WELSH";
})(SpecialCommunicationsPreference || (exports.SpecialCommunicationsPreference = SpecialCommunicationsPreference = {}));
/** A list of the possible meter reading types. */
var StatementReadType;
(function (StatementReadType) {
    StatementReadType["EstimatedReading"] = "ESTIMATED_READING";
    StatementReadType["ManualReading"] = "MANUAL_READING";
    StatementReadType["OnsiteReading"] = "ONSITE_READING";
    StatementReadType["SmartReading"] = "SMART_READING";
})(StatementReadType || (exports.StatementReadType = StatementReadType = {}));
/** Lists the types of statements that can be created. */
var StatementType;
(function (StatementType) {
    StatementType["Draft"] = "DRAFT";
    StatementType["Final"] = "FINAL";
    StatementType["InLife"] = "IN_LIFE";
})(StatementType || (exports.StatementType = StatementType = {}));
/** The case sensitivity of a string search. */
var StringSearchCaseSensitivity;
(function (StringSearchCaseSensitivity) {
    /** Allows case insensitive searches, for example `DistributorA` would match `distributorA`. */
    StringSearchCaseSensitivity["CaseInsensitive"] = "CASE_INSENSITIVE";
    /** Only entries that match the case will be returned. */
    StringSearchCaseSensitivity["CaseSensitive"] = "CASE_SENSITIVE";
})(StringSearchCaseSensitivity || (exports.StringSearchCaseSensitivity = StringSearchCaseSensitivity = {}));
/** The type of match for a string search. */
var StringSearchMatcher;
(function (StringSearchMatcher) {
    /** Only entries that match exactly will be returned. */
    StringSearchMatcher["Exact"] = "EXACT";
    /** Permits partial string matches, for example `cat` would match `concatenate`. */
    StringSearchMatcher["Partial"] = "PARTIAL";
})(StringSearchMatcher || (exports.StringSearchMatcher = StringSearchMatcher = {}));
/** The values for the type of the subject. */
var SubjectType;
(function (SubjectType) {
    SubjectType["Account"] = "ACCOUNT";
    SubjectType["ReadDispute"] = "READ_DISPUTE";
    SubjectType["SupplyPoint"] = "SUPPLY_POINT";
})(SubjectType || (exports.SubjectType = SubjectType = {}));
/** The type of fuel for a supply point - gas or electricity. */
var SupplyFuel;
(function (SupplyFuel) {
    SupplyFuel["Electricity"] = "ELECTRICITY";
    SupplyFuel["Gas"] = "GAS";
})(SupplyFuel || (exports.SupplyFuel = SupplyFuel = {}));
/** A list of the possible timing categories for a supply point. */
var SupplyPointTimingCategory;
(function (SupplyPointTimingCategory) {
    SupplyPointTimingCategory["Anytime"] = "ANYTIME";
    SupplyPointTimingCategory["ControlledLoad_1"] = "CONTROLLED_LOAD_1";
    SupplyPointTimingCategory["ControlledLoad_2"] = "CONTROLLED_LOAD_2";
    SupplyPointTimingCategory["ControlledLoad_3"] = "CONTROLLED_LOAD_3";
    SupplyPointTimingCategory["EveningAndWeekend"] = "EVENING_AND_WEEKEND";
    SupplyPointTimingCategory["Heating"] = "HEATING";
    SupplyPointTimingCategory["Interval"] = "INTERVAL";
    SupplyPointTimingCategory["OffPeak"] = "OFF_PEAK";
    SupplyPointTimingCategory["Peak"] = "PEAK";
    SupplyPointTimingCategory["Shoulder"] = "SHOULDER";
    SupplyPointTimingCategory["Solar"] = "SOLAR";
})(SupplyPointTimingCategory || (exports.SupplyPointTimingCategory = SupplyPointTimingCategory = {}));
/** The mechanism by which the customer pays for the tariff, e.g. pay-as-you-go. */
var TariffPaymentMechanism;
(function (TariffPaymentMechanism) {
    TariffPaymentMechanism["Other"] = "OTHER";
    /** Pay-as-you-go */
    TariffPaymentMechanism["Payg"] = "PAYG";
    /** Pay Monthly */
    TariffPaymentMechanism["Paym"] = "PAYM";
})(TariffPaymentMechanism || (exports.TariffPaymentMechanism = TariffPaymentMechanism = {}));
/** The method by which the customer pays for the tariff, e.g. Direct Debit. */
var TariffPaymentMethod;
(function (TariffPaymentMethod) {
    TariffPaymentMethod["DirectDebit"] = "DIRECT_DEBIT";
    TariffPaymentMethod["InArrears"] = "IN_ARREARS";
    TariffPaymentMethod["OnDemand"] = "ON_DEMAND";
    TariffPaymentMethod["Prepayment"] = "PREPAYMENT";
    TariffPaymentMethod["Recurring"] = "RECURRING";
})(TariffPaymentMethod || (exports.TariffPaymentMethod = TariffPaymentMethod = {}));
/** The type of the tariff (either fixed or variable). */
var TariffType;
(function (TariffType) {
    TariffType["Fixed"] = "FIXED";
    TariffType["Variable"] = "VARIABLE";
})(TariffType || (exports.TariffType = TariffType = {}));
/** Tax Category */
var TaxCategory;
(function (TaxCategory) {
    TaxCategory["NoTax"] = "NO_TAX";
    TaxCategory["Reduced"] = "REDUCED";
    TaxCategory["Standard"] = "STANDARD";
})(TaxCategory || (exports.TaxCategory = TaxCategory = {}));
/** The type of search that can be done on a time of use label. */
var TimeOfUseSearchType;
(function (TimeOfUseSearchType) {
    /** Only entries that match exactly will be returned. */
    TimeOfUseSearchType["Exact"] = "EXACT";
    /** Permits partial string matches, for example `cat` would match `concatenate`. */
    TimeOfUseSearchType["Partial"] = "PARTIAL";
})(TimeOfUseSearchType || (exports.TimeOfUseSearchType = TimeOfUseSearchType = {}));
/** Register type. */
var TimingCategory;
(function (TimingCategory) {
    TimingCategory["Anytime"] = "ANYTIME";
    TimingCategory["ControlledLoad_1"] = "CONTROLLED_LOAD_1";
    TimingCategory["ControlledLoad_2"] = "CONTROLLED_LOAD_2";
    TimingCategory["Heating"] = "HEATING";
    TimingCategory["Interval"] = "INTERVAL";
    TimingCategory["Offpeak"] = "OFFPEAK";
    TimingCategory["Peak"] = "PEAK";
    TimingCategory["Solar"] = "SOLAR";
})(TimingCategory || (exports.TimingCategory = TimingCategory = {}));
/**
 * Indicates how the year is divided up into smaller parts, if at all.
 * This allows us to apply different configurations to different months, weeks, or each day of the year individually.
 */
var TimingConfigurationSeasonality;
(function (TimingConfigurationSeasonality) {
    TimingConfigurationSeasonality["Month"] = "MONTH";
    TimingConfigurationSeasonality["None"] = "NONE";
    TimingConfigurationSeasonality["Other"] = "OTHER";
})(TimingConfigurationSeasonality || (exports.TimingConfigurationSeasonality = TimingConfigurationSeasonality = {}));
/** The origin of a tokenised payment. */
var TokenisedPaymentOrigin;
(function (TokenisedPaymentOrigin) {
    TokenisedPaymentOrigin["Internet"] = "INTERNET";
    TokenisedPaymentOrigin["Phone"] = "PHONE";
})(TokenisedPaymentOrigin || (exports.TokenisedPaymentOrigin = TokenisedPaymentOrigin = {}));
/**
 * The category grouping of the type of transaction that has been applied which drives certain behaviours such as:
 * - Whether the transaction can be either a credit or a debit or both
 * - Which section it appears in on a bill
 * - Which balance total the transaction counts towards
 */
var TransactionBalanceCategory;
(function (TransactionBalanceCategory) {
    TransactionBalanceCategory["Charges"] = "CHARGES";
    TransactionBalanceCategory["Credits"] = "CREDITS";
    TransactionBalanceCategory["Payments"] = "PAYMENTS";
    TransactionBalanceCategory["Refunds"] = "REFUNDS";
})(TransactionBalanceCategory || (exports.TransactionBalanceCategory = TransactionBalanceCategory = {}));
/**
 * List of roles for a customer against an account. To be used when updating roles during the transition period to the new model.
 * This only contains roles that are present solely in the new model.
 * In order to update the financially liable role on a relationship, use the updateCustomerAccountRelationship mutation to amend V1 of the relationship. This data will then be synced with the newer model.
 */
var UpdateCustomerAccountRole_NextV1;
(function (UpdateCustomerAccountRole_NextV1) {
    /** This is used to indicate that the attached customer is a victim of domestic violence. */
    UpdateCustomerAccountRole_NextV1["DomesticViolence"] = "DOMESTIC_VIOLENCE";
    /**
     * This denotes the customer is financially responsible for payment on the account.
     * This has no bearing on access to payment related capability within the extended platform such as amending the payment instruction. This is restricted to customers that have a relationship with the relevant payment mandate.
     */
    UpdateCustomerAccountRole_NextV1["FinanciallyLiable"] = "FINANCIALLY_LIABLE";
    /** This is used to indicate that the attached customer is a landlord. */
    UpdateCustomerAccountRole_NextV1["Landlord"] = "LANDLORD";
    /** This is used to indicate that the attached customer is not eligible for a refund after a final bill. */
    UpdateCustomerAccountRole_NextV1["NoRefund"] = "NO_REFUND";
    /** This is used to indicate that the attached customer is a partner. */
    UpdateCustomerAccountRole_NextV1["Partner"] = "PARTNER";
    /** This is used to indicate that the attached customer is eligible to act on behalf of the primary account holder. */
    UpdateCustomerAccountRole_NextV1["PowerOfAttorney"] = "POWER_OF_ATTORNEY";
})(UpdateCustomerAccountRole_NextV1 || (exports.UpdateCustomerAccountRole_NextV1 = UpdateCustomerAccountRole_NextV1 = {}));
/** Available urgent charging modes. */
var UrgentChargeMode;
(function (UrgentChargeMode) {
    /** Disable urgent charging */
    UrgentChargeMode["Disabled"] = "DISABLED";
    /** Enable urgent charging. */
    UrgentChargeMode["Enabled"] = "ENABLED";
})(UrgentChargeMode || (exports.UrgentChargeMode = UrgentChargeMode = {}));
/** A list of possible types of usage. */
var UsageType;
(function (UsageType) {
    UsageType["Actual"] = "ACTUAL";
    UsageType["Estimate"] = "ESTIMATE";
})(UsageType || (exports.UsageType = UsageType = {}));
/** A list showing the types of validation failure: basic or advanced. */
var ValidationType;
(function (ValidationType) {
    ValidationType["Advanced"] = "ADVANCED";
    ValidationType["Basic"] = "BASIC";
})(ValidationType || (exports.ValidationType = ValidationType = {}));
